(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._tooltip_13k1h_27{width:260px}._popover_13k1h_31{background:#fff;border-radius:4px;border:1px solid #e7ecf3;box-shadow:0 8px 16px #6176981a,0 4px 8px #6176980a;box-sizing:border-box;z-index:100}._bar_12q02_27{overflow:hidden}._section_12q02_31{position:relative}._sectionHidden_12q02_34{display:none!important}._sectionInheritRadius_12q02_37{border-radius:inherit}._valueOutside_12q02_41{position:absolute;left:calc(100% + 4px);z-index:1}._container_1t2a7_1{overflow:hidden}._root_l5gsy_27{display:grid;column-gap:8px;row-gap:16px;white-space:nowrap}._root_l5gsy_27:not(._rootBounded_l5gsy_33):not(._rootFluid_l5gsy_33){grid-template-columns:repeat(auto-fit,minmax(min(100% / 2 - 8px * (2 - 1) / 2,max(96px,100% / 6 - 8px * (6 - 1) / 6)),1fr))}._rootFluid_l5gsy_33,._rootBounded_l5gsy_33{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_l5gsy_33{max-width:616px}._wrapper_md8oe_27{display:inline-flex;align-self:flex-start}._text_md8oe_32{font-size:24px}._colorIndicator_luubh_1{width:6px;height:6px;border-radius:50%;flex-shrink:0}._legendItem_17mul_27{flex-shrink:0;overflow:hidden;white-space:nowrap;cursor:pointer;opacity:1}._legendItemInactive_17mul_34{opacity:.4}._legendIcon_17mul_38{flex-shrink:0;width:12px;border-radius:2px;border:1px solid #e7ecf3;box-sizing:border-box}._legendIconBar_17mul_45{height:12px}._legendIconLine_17mul_48{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_1drwm_27{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;cursor:default;opacity:1;transition:opacity .2s ease-in-out}._cell_1drwm_27:hover ._cellText_1drwm_37{color:#132244}._cellDimmed_1drwm_40{opacity:.2}._cellContent_1drwm_44{display:flex;align-items:center;justify-content:center;width:100%;height:100%}._cellText_1drwm_37{transition:color .2s ease-in-out}._grid_1az0f_27{display:grid;grid-auto-rows:minmax(32px,1fr);flex-grow:1}._row_1az0f_33{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;text-align:center}._legend_jf6br_27{position:relative}._trigger_jf6br_31{position:absolute;top:-50%;right:0}._popover_jf6br_37{width:256px;max-height:298px;padding:16px;z-index:100;box-sizing:border-box;background:#fff;border-radius:4px;border:1px solid #e7ecf3;box-shadow:0 8px 16px #6176981a,0 4px 8px #6176980a;margin:0 8px;overflow-y:auto;background:linear-gradient(#fff 33%,#fff0),linear-gradient(#fff0,#fff 66%) 0 100%,radial-gradient(farthest-side at 50% 0,#d7dfea,#0000),radial-gradient(farthest-side at 50% 100%,#d7dfea,#0000) 0 100%;background-color:#fff;background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% 24px,100% 24px,100% 8px,100% 8px}._breakdown_jf6br_56{display:flex;flex-direction:column;gap:12px;list-style:none;margin:0;padding:0}._breakdown_jf6br_56 li{display:grid;grid-template-columns:1fr auto;gap:8px}._breakdown_jf6br_56 li>:first-child{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{position:relative;max-width:240px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_1xmkm_20{max-width:300px}")),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import * as T from "react";
import mr, { useCallback as q, createContext as Jn, useMemo as J, createElement as B, useContext as So, forwardRef as de, Children as lt, isValidElement as on, cloneElement as gn, Fragment as Oo, useEffect as ne, useRef as re, useState as Q, useLayoutEffect as br, useReducer as As, memo as he } from "react";
import { IconButton as yr, ButtonList as Fn, FlexBox as K, Text as W, Tooltip as Dt, Box as $r, ButtonGroup as Ao, Button as To, EmptyState as Ro, Divider as Ts, Table as me, HelpIcon as Rs, Pagination as js } from "@dixa/lib-shared-habla";
import { sizes as xr, colors as k, typography as ut, effects as Is } from "@dixa/lib-shared-tokens";
import * as Ds from "react-dom";
import Ms, { flushSync as jo } from "react-dom";
import Oe from "classnames";
import { usePrevious as Io, useInterval as Ns, useList as Fs, useUpdateEffect as Mt, useMap as Ls } from "react-use";
import { LabelList as ks, Cell as Vs, ResponsiveContainer as Bs, XAxis as Us, YAxis as Hs, CartesianGrid as Ws, ReferenceLine as zs, Label as Gs, Legend as Ks, Tooltip as Ys, LineChart as qs, BarChart as Xs, Line as Zs, Bar as Js } from "recharts";
import Le from "moment-timezone";
import { TagChips as Qs } from "lib-shared-tagging";
var Wt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function je(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ec(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Qn = { exports: {} }, Et = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa;
function tc() {
  if (aa) return Et;
  aa = 1;
  var e = mr, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, c, l) {
    var v, u = {}, p = null, d = null;
    l !== void 0 && (p = "" + l), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (v in c) r.call(c, v) && !o.hasOwnProperty(v) && (u[v] = c[v]);
    if (s && s.defaultProps) for (v in c = s.defaultProps, c) u[v] === void 0 && (u[v] = c[v]);
    return { $$typeof: t, type: s, key: p, ref: d, props: u, _owner: a.current };
  }
  return Et.Fragment = n, Et.jsx = i, Et.jsxs = i, Et;
}
var Pt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oa;
function nc() {
  return oa || (oa = 1, process.env.NODE_ENV !== "production" && function() {
    var e = mr, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), m = Symbol.iterator, h = "@@iterator";
    function b(f) {
      if (f === null || typeof f != "object")
        return null;
      var C = m && f[m] || f[h];
      return typeof C == "function" ? C : null;
    }
    var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(f) {
      {
        for (var C = arguments.length, P = new Array(C > 1 ? C - 1 : 0), R = 1; R < C; R++)
          P[R - 1] = arguments[R];
        x("error", f, P);
      }
    }
    function x(f, C, P) {
      {
        var R = $.ReactDebugCurrentFrame, V = R.getStackAddendum();
        V !== "" && (C += "%s", P = P.concat([V]));
        var H = P.map(function(L) {
          return String(L);
        });
        H.unshift("Warning: " + C), Function.prototype.apply.call(console[f], console, H);
      }
    }
    var _ = !1, w = !1, E = !1, O = !1, S = !1, A;
    A = Symbol.for("react.module.reference");
    function U(f) {
      return !!(typeof f == "string" || typeof f == "function" || f === r || f === o || S || f === a || f === l || f === v || O || f === d || _ || w || E || typeof f == "object" && f !== null && (f.$$typeof === p || f.$$typeof === u || f.$$typeof === i || f.$$typeof === s || f.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      f.$$typeof === A || f.getModuleId !== void 0));
    }
    function j(f, C, P) {
      var R = f.displayName;
      if (R)
        return R;
      var V = C.displayName || C.name || "";
      return V !== "" ? P + "(" + V + ")" : P;
    }
    function z(f) {
      return f.displayName || "Context";
    }
    function D(f) {
      if (f == null)
        return null;
      if (typeof f.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof f == "function")
        return f.displayName || f.name || null;
      if (typeof f == "string")
        return f;
      switch (f) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case l:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof f == "object")
        switch (f.$$typeof) {
          case s:
            var C = f;
            return z(C) + ".Consumer";
          case i:
            var P = f;
            return z(P._context) + ".Provider";
          case c:
            return j(f, f.render, "ForwardRef");
          case u:
            var R = f.displayName || null;
            return R !== null ? R : D(f.type) || "Memo";
          case p: {
            var V = f, H = V._payload, L = V._init;
            try {
              return D(L(H));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var I = Object.assign, Y = 0, M, ae, F, X, ie, $e, He;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function et() {
      {
        if (Y === 0) {
          M = console.log, ae = console.info, F = console.warn, X = console.error, ie = console.group, $e = console.groupCollapsed, He = console.groupEnd;
          var f = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: f,
            log: f,
            warn: f,
            error: f,
            group: f,
            groupCollapsed: f,
            groupEnd: f
          });
        }
        Y++;
      }
    }
    function Pe() {
      {
        if (Y--, Y === 0) {
          var f = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: I({}, f, {
              value: M
            }),
            info: I({}, f, {
              value: ae
            }),
            warn: I({}, f, {
              value: F
            }),
            error: I({}, f, {
              value: X
            }),
            group: I({}, f, {
              value: ie
            }),
            groupCollapsed: I({}, f, {
              value: $e
            }),
            groupEnd: I({}, f, {
              value: He
            })
          });
        }
        Y < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = $.ReactCurrentDispatcher, Se;
    function ge(f, C, P) {
      {
        if (Se === void 0)
          try {
            throw Error();
          } catch (V) {
            var R = V.stack.trim().match(/\n( *(at )?)/);
            Se = R && R[1] || "";
          }
        return `
` + Se + f;
      }
    }
    var xe = !1, Me;
    {
      var Sn = typeof WeakMap == "function" ? WeakMap : Map;
      Me = new Sn();
    }
    function Bt(f, C) {
      if (!f || xe)
        return "";
      {
        var P = Me.get(f);
        if (P !== void 0)
          return P;
      }
      var R;
      xe = !0;
      var V = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var H;
      H = le.current, le.current = null, et();
      try {
        if (C) {
          var L = function() {
            throw Error();
          };
          if (Object.defineProperty(L.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(L, []);
            } catch (ce) {
              R = ce;
            }
            Reflect.construct(f, [], L);
          } else {
            try {
              L.call();
            } catch (ce) {
              R = ce;
            }
            f.call(L.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ce) {
            R = ce;
          }
          f();
        }
      } catch (ce) {
        if (ce && R && typeof ce.stack == "string") {
          for (var N = ce.stack.split(`
`), se = R.stack.split(`
`), Z = N.length - 1, ee = se.length - 1; Z >= 1 && ee >= 0 && N[Z] !== se[ee]; )
            ee--;
          for (; Z >= 1 && ee >= 0; Z--, ee--)
            if (N[Z] !== se[ee]) {
              if (Z !== 1 || ee !== 1)
                do
                  if (Z--, ee--, ee < 0 || N[Z] !== se[ee]) {
                    var pe = `
` + N[Z].replace(" at new ", " at ");
                    return f.displayName && pe.includes("<anonymous>") && (pe = pe.replace("<anonymous>", f.displayName)), typeof f == "function" && Me.set(f, pe), pe;
                  }
                while (Z >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        xe = !1, le.current = H, Pe(), Error.prepareStackTrace = V;
      }
      var at = f ? f.displayName || f.name : "", We = at ? ge(at) : "";
      return typeof f == "function" && Me.set(f, We), We;
    }
    function On(f, C, P) {
      return Bt(f, !1);
    }
    function An(f) {
      var C = f.prototype;
      return !!(C && C.isReactComponent);
    }
    function _e(f, C, P) {
      if (f == null)
        return "";
      if (typeof f == "function")
        return Bt(f, An(f));
      if (typeof f == "string")
        return ge(f);
      switch (f) {
        case l:
          return ge("Suspense");
        case v:
          return ge("SuspenseList");
      }
      if (typeof f == "object")
        switch (f.$$typeof) {
          case c:
            return On(f.render);
          case u:
            return _e(f.type, C, P);
          case p: {
            var R = f, V = R._payload, H = R._init;
            try {
              return _e(H(V), C, P);
            } catch {
            }
          }
        }
      return "";
    }
    var Ne = Object.prototype.hasOwnProperty, Ut = {}, Ht = $.ReactDebugCurrentFrame;
    function tt(f) {
      if (f) {
        var C = f._owner, P = _e(f.type, f._source, C ? C.type : null);
        Ht.setExtraStackFrame(P);
      } else
        Ht.setExtraStackFrame(null);
    }
    function Tn(f, C, P, R, V) {
      {
        var H = Function.call.bind(Ne);
        for (var L in f)
          if (H(f, L)) {
            var N = void 0;
            try {
              if (typeof f[L] != "function") {
                var se = Error((R || "React class") + ": " + P + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw se.name = "Invariant Violation", se;
              }
              N = f[L](C, L, R, P, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Z) {
              N = Z;
            }
            N && !(N instanceof Error) && (tt(V), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", R || "React class", P, L, typeof N), tt(null)), N instanceof Error && !(N.message in Ut) && (Ut[N.message] = !0, tt(V), y("Failed %s type: %s", P, N.message), tt(null));
          }
      }
    }
    var nt = Array.isArray;
    function Rn(f) {
      return nt(f);
    }
    function ls(f) {
      {
        var C = typeof Symbol == "function" && Symbol.toStringTag, P = C && f[Symbol.toStringTag] || f.constructor.name || "Object";
        return P;
      }
    }
    function us(f) {
      try {
        return Kr(f), !1;
      } catch {
        return !0;
      }
    }
    function Kr(f) {
      return "" + f;
    }
    function Yr(f) {
      if (us(f))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ls(f)), Kr(f);
    }
    var Ct = $.ReactCurrentOwner, fs = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, qr, Xr, jn;
    jn = {};
    function ds(f) {
      if (Ne.call(f, "ref")) {
        var C = Object.getOwnPropertyDescriptor(f, "ref").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return f.ref !== void 0;
    }
    function ps(f) {
      if (Ne.call(f, "key")) {
        var C = Object.getOwnPropertyDescriptor(f, "key").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return f.key !== void 0;
    }
    function vs(f, C) {
      if (typeof f.ref == "string" && Ct.current && C && Ct.current.stateNode !== C) {
        var P = D(Ct.current.type);
        jn[P] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(Ct.current.type), f.ref), jn[P] = !0);
      }
    }
    function hs(f, C) {
      {
        var P = function() {
          qr || (qr = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        P.isReactWarning = !0, Object.defineProperty(f, "key", {
          get: P,
          configurable: !0
        });
      }
    }
    function gs(f, C) {
      {
        var P = function() {
          Xr || (Xr = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        P.isReactWarning = !0, Object.defineProperty(f, "ref", {
          get: P,
          configurable: !0
        });
      }
    }
    var ms = function(f, C, P, R, V, H, L) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: f,
        key: C,
        ref: P,
        props: L,
        // Record the component responsible for creating this element.
        _owner: H
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: V
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function bs(f, C, P, R, V) {
      {
        var H, L = {}, N = null, se = null;
        P !== void 0 && (Yr(P), N = "" + P), ps(C) && (Yr(C.key), N = "" + C.key), ds(C) && (se = C.ref, vs(C, V));
        for (H in C)
          Ne.call(C, H) && !fs.hasOwnProperty(H) && (L[H] = C[H]);
        if (f && f.defaultProps) {
          var Z = f.defaultProps;
          for (H in Z)
            L[H] === void 0 && (L[H] = Z[H]);
        }
        if (N || se) {
          var ee = typeof f == "function" ? f.displayName || f.name || "Unknown" : f;
          N && hs(L, ee), se && gs(L, ee);
        }
        return ms(f, N, se, V, R, Ct.current, L);
      }
    }
    var In = $.ReactCurrentOwner, Zr = $.ReactDebugCurrentFrame;
    function rt(f) {
      if (f) {
        var C = f._owner, P = _e(f.type, f._source, C ? C.type : null);
        Zr.setExtraStackFrame(P);
      } else
        Zr.setExtraStackFrame(null);
    }
    var Dn;
    Dn = !1;
    function Mn(f) {
      return typeof f == "object" && f !== null && f.$$typeof === t;
    }
    function Jr() {
      {
        if (In.current) {
          var f = D(In.current.type);
          if (f)
            return `

Check the render method of \`` + f + "`.";
        }
        return "";
      }
    }
    function ys(f) {
      return "";
    }
    var Qr = {};
    function $s(f) {
      {
        var C = Jr();
        if (!C) {
          var P = typeof f == "string" ? f : f.displayName || f.name;
          P && (C = `

Check the top-level render call using <` + P + ">.");
        }
        return C;
      }
    }
    function ea(f, C) {
      {
        if (!f._store || f._store.validated || f.key != null)
          return;
        f._store.validated = !0;
        var P = $s(C);
        if (Qr[P])
          return;
        Qr[P] = !0;
        var R = "";
        f && f._owner && f._owner !== In.current && (R = " It was passed a child from " + D(f._owner.type) + "."), rt(f), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', P, R), rt(null);
      }
    }
    function ta(f, C) {
      {
        if (typeof f != "object")
          return;
        if (Rn(f))
          for (var P = 0; P < f.length; P++) {
            var R = f[P];
            Mn(R) && ea(R, C);
          }
        else if (Mn(f))
          f._store && (f._store.validated = !0);
        else if (f) {
          var V = b(f);
          if (typeof V == "function" && V !== f.entries)
            for (var H = V.call(f), L; !(L = H.next()).done; )
              Mn(L.value) && ea(L.value, C);
        }
      }
    }
    function xs(f) {
      {
        var C = f.type;
        if (C == null || typeof C == "string")
          return;
        var P;
        if (typeof C == "function")
          P = C.propTypes;
        else if (typeof C == "object" && (C.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        C.$$typeof === u))
          P = C.propTypes;
        else
          return;
        if (P) {
          var R = D(C);
          Tn(P, f.props, "prop", R, f);
        } else if (C.PropTypes !== void 0 && !Dn) {
          Dn = !0;
          var V = D(C);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", V || "Unknown");
        }
        typeof C.getDefaultProps == "function" && !C.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function _s(f) {
      {
        for (var C = Object.keys(f.props), P = 0; P < C.length; P++) {
          var R = C[P];
          if (R !== "children" && R !== "key") {
            rt(f), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", R), rt(null);
            break;
          }
        }
        f.ref !== null && (rt(f), y("Invalid attribute `ref` supplied to `React.Fragment`."), rt(null));
      }
    }
    var na = {};
    function ra(f, C, P, R, V, H) {
      {
        var L = U(f);
        if (!L) {
          var N = "";
          (f === void 0 || typeof f == "object" && f !== null && Object.keys(f).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var se = ys();
          se ? N += se : N += Jr();
          var Z;
          f === null ? Z = "null" : Rn(f) ? Z = "array" : f !== void 0 && f.$$typeof === t ? (Z = "<" + (D(f.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : Z = typeof f, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Z, N);
        }
        var ee = bs(f, C, P, V, H);
        if (ee == null)
          return ee;
        if (L) {
          var pe = C.children;
          if (pe !== void 0)
            if (R)
              if (Rn(pe)) {
                for (var at = 0; at < pe.length; at++)
                  ta(pe[at], f);
                Object.freeze && Object.freeze(pe);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ta(pe, f);
        }
        if (Ne.call(C, "key")) {
          var We = D(f), ce = Object.keys(C).filter(function(Os) {
            return Os !== "key";
          }), Nn = ce.length > 0 ? "{key: someKey, " + ce.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!na[We + Nn]) {
            var Ss = ce.length > 0 ? "{" + ce.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Nn, We, Ss, We), na[We + Nn] = !0;
          }
        }
        return f === r ? _s(ee) : xs(ee), ee;
      }
    }
    function ws(f, C, P) {
      return ra(f, C, P, !0);
    }
    function Cs(f, C, P) {
      return ra(f, C, P, !1);
    }
    var Es = Cs, Ps = ws;
    Pt.Fragment = r, Pt.jsx = Es, Pt.jsxs = Ps;
  }()), Pt;
}
process.env.NODE_ENV === "production" ? Qn.exports = tc() : Qn.exports = nc();
var g = Qn.exports;
function oe() {
  return oe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, oe.apply(this, arguments);
}
function Ge(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented) return t == null ? void 0 : t(a);
  };
}
function rc(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Do(...e) {
  return (t) => e.forEach(
    (n) => rc(n, t)
  );
}
function qe(...e) {
  return q(Do(...e), e);
}
function Mo(e, t = []) {
  let n = [];
  function r(o, i) {
    const s = /* @__PURE__ */ Jn(i), c = n.length;
    n = [
      ...n,
      i
    ];
    function l(u) {
      const { scope: p, children: d, ...m } = u, h = (p == null ? void 0 : p[e][c]) || s, b = J(
        () => m,
        Object.values(m)
      );
      return /* @__PURE__ */ B(h.Provider, {
        value: b
      }, d);
    }
    function v(u, p) {
      const d = (p == null ? void 0 : p[e][c]) || s, m = So(d);
      if (m) return m;
      if (i !== void 0) return i;
      throw new Error(`\`${u}\` must be used within \`${o}\``);
    }
    return l.displayName = o + "Provider", [
      l,
      v
    ];
  }
  const a = () => {
    const o = n.map((i) => /* @__PURE__ */ Jn(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return J(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    ac(a, ...t)
  ];
}
function ac(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(o) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(o)[`__scope${l}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return J(
        () => ({
          [`__scope${t.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const _r = /* @__PURE__ */ de((e, t) => {
  const { children: n, ...r } = e, a = lt.toArray(n), o = a.find(ic);
  if (o) {
    const i = o.props.children, s = a.map((c) => c === o ? lt.count(i) > 1 ? lt.only(null) : /* @__PURE__ */ on(i) ? i.props.children : null : c);
    return /* @__PURE__ */ B(er, oe({}, r, {
      ref: t
    }), /* @__PURE__ */ on(i) ? /* @__PURE__ */ gn(i, void 0, s) : null);
  }
  return /* @__PURE__ */ B(er, oe({}, r, {
    ref: t
  }), n);
});
_r.displayName = "Slot";
const er = /* @__PURE__ */ de((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ on(n) ? /* @__PURE__ */ gn(n, {
    ...sc(r, n.props),
    ref: t ? Do(t, n.ref) : n.ref
  }) : lt.count(n) > 1 ? lt.only(null) : null;
});
er.displayName = "SlotClone";
const oc = ({ children: e }) => /* @__PURE__ */ B(Oo, null, e);
function ic(e) {
  return /* @__PURE__ */ on(e) && e.type === oc;
}
function sc(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? a && o ? n[r] = (...s) => {
      o(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...o
    } : r === "className" && (n[r] = [
      a,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const cc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ht = cc.reduce((e, t) => {
  const n = /* @__PURE__ */ de((r, a) => {
    const { asChild: o, ...i } = r, s = o ? _r : t;
    return ne(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ B(s, oe({}, i, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function lc(e, t) {
  e && jo(
    () => e.dispatchEvent(t)
  );
}
function ke(e) {
  const t = re(e);
  return ne(() => {
    t.current = e;
  }), J(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function uc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ke(e);
  ne(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const tr = "dismissableLayer.update", fc = "dismissableLayer.pointerDownOutside", dc = "dismissableLayer.focusOutside";
let ia;
const pc = /* @__PURE__ */ Jn({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), vc = /* @__PURE__ */ de((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: a, onPointerDownOutside: o, onFocusOutside: i, onInteractOutside: s, onDismiss: c, ...l } = e, v = So(pc), [u, p] = Q(null), d = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, m] = Q({}), h = qe(
    t,
    (S) => p(S)
  ), b = Array.from(v.layers), [$] = [
    ...v.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = b.indexOf($), x = u ? b.indexOf(u) : -1, _ = v.layersWithOutsidePointerEventsDisabled.size > 0, w = x >= y, E = hc((S) => {
    const A = S.target, U = [
      ...v.branches
    ].some(
      (j) => j.contains(A)
    );
    !w || U || (o == null || o(S), s == null || s(S), S.defaultPrevented || c == null || c());
  }, d), O = gc((S) => {
    const A = S.target;
    [
      ...v.branches
    ].some(
      (j) => j.contains(A)
    ) || (i == null || i(S), s == null || s(S), S.defaultPrevented || c == null || c());
  }, d);
  return uc((S) => {
    x === v.layers.size - 1 && (a == null || a(S), !S.defaultPrevented && c && (S.preventDefault(), c()));
  }, d), ne(() => {
    if (u)
      return r && (v.layersWithOutsidePointerEventsDisabled.size === 0 && (ia = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), v.layersWithOutsidePointerEventsDisabled.add(u)), v.layers.add(u), sa(), () => {
        r && v.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = ia);
      };
  }, [
    u,
    d,
    r,
    v
  ]), ne(() => () => {
    u && (v.layers.delete(u), v.layersWithOutsidePointerEventsDisabled.delete(u), sa());
  }, [
    u,
    v
  ]), ne(() => {
    const S = () => m({});
    return document.addEventListener(tr, S), () => document.removeEventListener(tr, S);
  }, []), /* @__PURE__ */ B(ht.div, oe({}, l, {
    ref: h,
    style: {
      pointerEvents: _ ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Ge(e.onFocusCapture, O.onFocusCapture),
    onBlurCapture: Ge(e.onBlurCapture, O.onBlurCapture),
    onPointerDownCapture: Ge(e.onPointerDownCapture, E.onPointerDownCapture)
  }));
});
function hc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ke(e), r = re(!1), a = re(() => {
  });
  return ne(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          No(fc, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = l, t.addEventListener("click", a.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", o), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function gc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ke(e), r = re(!1);
  return ne(() => {
    const a = (o) => {
      o.target && !r.current && No(dc, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function sa() {
  const e = new CustomEvent(tr);
  document.dispatchEvent(e);
}
function No(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, o = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), r ? lc(a, o) : a.dispatchEvent(o);
}
let Ln = 0;
function mc() {
  ne(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : ca()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : ca()), Ln++, () => {
      Ln === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Ln--;
    };
  }, []);
}
function ca() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const kn = "focusScope.autoFocusOnMount", Vn = "focusScope.autoFocusOnUnmount", la = {
  bubbles: !1,
  cancelable: !0
}, bc = /* @__PURE__ */ de((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: a, onUnmountAutoFocus: o, ...i } = e, [s, c] = Q(null), l = ke(a), v = ke(o), u = re(null), p = qe(
    t,
    (h) => c(h)
  ), d = re({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ne(() => {
    if (r) {
      let h = function(x) {
        if (d.paused || !s) return;
        const _ = x.target;
        s.contains(_) ? u.current = _ : Fe(u.current, {
          select: !0
        });
      }, b = function(x) {
        if (d.paused || !s) return;
        const _ = x.relatedTarget;
        _ !== null && (s.contains(_) || Fe(u.current, {
          select: !0
        }));
      }, $ = function(x) {
        if (document.activeElement === document.body)
          for (const w of x) w.removedNodes.length > 0 && Fe(s);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const y = new MutationObserver($);
      return s && y.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), y.disconnect();
      };
    }
  }, [
    r,
    s,
    d.paused
  ]), ne(() => {
    if (s) {
      fa.add(d);
      const h = document.activeElement;
      if (!s.contains(h)) {
        const $ = new CustomEvent(kn, la);
        s.addEventListener(kn, l), s.dispatchEvent($), $.defaultPrevented || (yc(Cc(Fo(s)), {
          select: !0
        }), document.activeElement === h && Fe(s));
      }
      return () => {
        s.removeEventListener(kn, l), setTimeout(() => {
          const $ = new CustomEvent(Vn, la);
          s.addEventListener(Vn, v), s.dispatchEvent($), $.defaultPrevented || Fe(h ?? document.body, {
            select: !0
          }), s.removeEventListener(Vn, v), fa.remove(d);
        }, 0);
      };
    }
  }, [
    s,
    l,
    v,
    d
  ]);
  const m = q((h) => {
    if (!n && !r || d.paused) return;
    const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, $ = document.activeElement;
    if (b && $) {
      const y = h.currentTarget, [x, _] = $c(y);
      x && _ ? !h.shiftKey && $ === _ ? (h.preventDefault(), n && Fe(x, {
        select: !0
      })) : h.shiftKey && $ === x && (h.preventDefault(), n && Fe(_, {
        select: !0
      })) : $ === y && h.preventDefault();
    }
  }, [
    n,
    r,
    d.paused
  ]);
  return /* @__PURE__ */ B(ht.div, oe({
    tabIndex: -1
  }, i, {
    ref: p,
    onKeyDown: m
  }));
});
function yc(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Fe(r, {
      select: t
    }), document.activeElement !== n) return;
}
function $c(e) {
  const t = Fo(e), n = ua(t, e), r = ua(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Fo(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ua(e, t) {
  for (const n of e)
    if (!xc(n, {
      upTo: t
    })) return n;
}
function xc(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function _c(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Fe(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && _c(e) && t && e.select();
  }
}
const fa = wc();
function wc() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = da(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = da(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function da(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Cc(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const pt = globalThis != null && globalThis.document ? br : () => {
}, Ec = T.useId || (() => {
});
let Pc = 0;
function Sc(e) {
  const [t, n] = T.useState(Ec());
  return pt(() => {
    e || n(
      (r) => r ?? String(Pc++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const Oc = ["top", "right", "bottom", "left"], Ve = Math.min, ue = Math.max, sn = Math.round, zt = Math.floor, Be = (e) => ({
  x: e,
  y: e
}), Ac = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Tc = {
  start: "end",
  end: "start"
};
function nr(e, t, n) {
  return ue(e, Ve(t, n));
}
function Ae(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Te(e) {
  return e.split("-")[0];
}
function gt(e) {
  return e.split("-")[1];
}
function wr(e) {
  return e === "x" ? "y" : "x";
}
function Cr(e) {
  return e === "y" ? "height" : "width";
}
function mt(e) {
  return ["top", "bottom"].includes(Te(e)) ? "y" : "x";
}
function Er(e) {
  return wr(mt(e));
}
function Rc(e, t, n) {
  n === void 0 && (n = !1);
  const r = gt(e), a = Er(e), o = Cr(a);
  let i = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (i = cn(i)), [i, cn(i)];
}
function jc(e) {
  const t = cn(e);
  return [rr(e), t, rr(t)];
}
function rr(e) {
  return e.replace(/start|end/g, (t) => Tc[t]);
}
function Ic(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], o = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? o : i;
    default:
      return [];
  }
}
function Dc(e, t, n, r) {
  const a = gt(e);
  let o = Ic(Te(e), n === "start", r);
  return a && (o = o.map((i) => i + "-" + a), t && (o = o.concat(o.map(rr)))), o;
}
function cn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ac[t]);
}
function Mc(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Lo(e) {
  return typeof e != "number" ? Mc(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ln(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function pa(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const o = mt(t), i = Er(t), s = Cr(i), c = Te(t), l = o === "y", v = r.x + r.width / 2 - a.width / 2, u = r.y + r.height / 2 - a.height / 2, p = r[s] / 2 - a[s] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: v,
        y: r.y - a.height
      };
      break;
    case "bottom":
      d = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      d = {
        x: r.x - a.width,
        y: u
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (gt(t)) {
    case "start":
      d[i] -= p * (n && l ? -1 : 1);
      break;
    case "end":
      d[i] += p * (n && l ? -1 : 1);
      break;
  }
  return d;
}
const Nc = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: i
  } = n, s = o.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: v,
    y: u
  } = pa(l, r, c), p = r, d = {}, m = 0;
  for (let h = 0; h < s.length; h++) {
    const {
      name: b,
      fn: $
    } = s[h], {
      x: y,
      y: x,
      data: _,
      reset: w
    } = await $({
      x: v,
      y: u,
      initialPlacement: r,
      placement: p,
      strategy: a,
      middlewareData: d,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (v = y ?? v, u = x ?? u, d = {
      ...d,
      [b]: {
        ...d[b],
        ..._
      }
    }, w && m <= 50) {
      m++, typeof w == "object" && (w.placement && (p = w.placement), w.rects && (l = w.rects === !0 ? await i.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : w.rects), {
        x: v,
        y: u
      } = pa(l, p, c)), h = -1;
      continue;
    }
  }
  return {
    x: v,
    y: u,
    placement: p,
    strategy: a,
    middlewareData: d
  };
};
async function Rt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: o,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: u = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = Ae(t, e), m = Lo(d), b = s[p ? u === "floating" ? "reference" : "floating" : u], $ = ln(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(b))) == null || n ? b : b.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: v,
    strategy: c
  })), y = u === "floating" ? {
    ...i.floating,
    x: r,
    y: a
  } : i.reference, x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), _ = await (o.isElement == null ? void 0 : o.isElement(x)) ? await (o.getScale == null ? void 0 : o.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = ln(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: y,
    offsetParent: x,
    strategy: c
  }) : y);
  return {
    top: ($.top - w.top + m.top) / _.y,
    bottom: (w.bottom - $.bottom + m.bottom) / _.y,
    left: ($.left - w.left + m.left) / _.x,
    right: (w.right - $.right + m.right) / _.x
  };
}
const va = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: o,
      platform: i,
      elements: s
    } = t, {
      element: c,
      padding: l = 0
    } = Ae(e, t) || {};
    if (c == null)
      return {};
    const v = Lo(l), u = {
      x: n,
      y: r
    }, p = Er(a), d = Cr(p), m = await i.getDimensions(c), h = p === "y", b = h ? "top" : "left", $ = h ? "bottom" : "right", y = h ? "clientHeight" : "clientWidth", x = o.reference[d] + o.reference[p] - u[p] - o.floating[d], _ = u[p] - o.reference[p], w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let E = w ? w[y] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(w))) && (E = s.floating[y] || o.floating[d]);
    const O = x / 2 - _ / 2, S = E / 2 - m[d] / 2 - 1, A = Ve(v[b], S), U = Ve(v[$], S), j = A, z = E - m[d] - U, D = E / 2 - m[d] / 2 + O, I = nr(j, D, z), M = gt(a) != null && D != I && o.reference[d] / 2 - (D < j ? A : U) - m[d] / 2 < 0 ? D < j ? j - D : z - D : 0;
    return {
      [p]: u[p] - M,
      data: {
        [p]: I,
        centerOffset: D - I + M
      }
    };
  }
}), Fc = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: a,
        rects: o,
        initialPlacement: i,
        platform: s,
        elements: c
      } = t, {
        mainAxis: l = !0,
        crossAxis: v = !0,
        fallbackPlacements: u,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: d = "none",
        flipAlignment: m = !0,
        ...h
      } = Ae(e, t), b = Te(r), $ = Te(i) === i, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), x = u || ($ || !m ? [cn(i)] : jc(i));
      !u && d !== "none" && x.push(...Dc(i, m, d, y));
      const _ = [i, ...x], w = await Rt(t, h), E = [];
      let O = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (l && E.push(w[b]), v) {
        const j = Rc(r, o, y);
        E.push(w[j[0]], w[j[1]]);
      }
      if (O = [...O, {
        placement: r,
        overflows: E
      }], !E.every((j) => j <= 0)) {
        var S, A;
        const j = (((S = a.flip) == null ? void 0 : S.index) || 0) + 1, z = _[j];
        if (z)
          return {
            data: {
              index: j,
              overflows: O
            },
            reset: {
              placement: z
            }
          };
        let D = (A = O.filter((I) => I.overflows[0] <= 0).sort((I, Y) => I.overflows[1] - Y.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!D)
          switch (p) {
            case "bestFit": {
              var U;
              const I = (U = O.map((Y) => [Y.placement, Y.overflows.filter((M) => M > 0).reduce((M, ae) => M + ae, 0)]).sort((Y, M) => Y[1] - M[1])[0]) == null ? void 0 : U[0];
              I && (D = I);
              break;
            }
            case "initialPlacement":
              D = i;
              break;
          }
        if (r !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function ha(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ga(e) {
  return Oc.some((t) => e[t] >= 0);
}
const Lc = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = Ae(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await Rt(t, {
            ...a,
            elementContext: "reference"
          }), i = ha(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: ga(i)
            }
          };
        }
        case "escaped": {
          const o = await Rt(t, {
            ...a,
            altBoundary: !0
          }), i = ha(o, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: ga(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function kc(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), i = Te(n), s = gt(n), c = mt(n) === "y", l = ["left", "top"].includes(i) ? -1 : 1, v = o && c ? -1 : 1, u = Ae(t, e);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: m
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof m == "number" && (d = s === "end" ? m * -1 : m), c ? {
    x: d * v,
    y: p * l
  } : {
    x: p * l,
    y: d * v
  };
}
const Vc = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, a = await kc(t, e);
      return {
        x: n + a.x,
        y: r + a.y,
        data: a
      };
    }
  };
}, Bc = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: o = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: $,
              y
            } = b;
            return {
              x: $,
              y
            };
          }
        },
        ...c
      } = Ae(e, t), l = {
        x: n,
        y: r
      }, v = await Rt(t, c), u = mt(Te(a)), p = wr(u);
      let d = l[p], m = l[u];
      if (o) {
        const b = p === "y" ? "top" : "left", $ = p === "y" ? "bottom" : "right", y = d + v[b], x = d - v[$];
        d = nr(y, d, x);
      }
      if (i) {
        const b = u === "y" ? "top" : "left", $ = u === "y" ? "bottom" : "right", y = m + v[b], x = m - v[$];
        m = nr(y, m, x);
      }
      const h = s.fn({
        ...t,
        [p]: d,
        [u]: m
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r
        }
      };
    }
  };
}, Uc = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: o,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Ae(e, t), v = {
        x: n,
        y: r
      }, u = mt(a), p = wr(u);
      let d = v[p], m = v[u];
      const h = Ae(s, t), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (c) {
        const x = p === "y" ? "height" : "width", _ = o.reference[p] - o.floating[x] + b.mainAxis, w = o.reference[p] + o.reference[x] - b.mainAxis;
        d < _ ? d = _ : d > w && (d = w);
      }
      if (l) {
        var $, y;
        const x = p === "y" ? "width" : "height", _ = ["top", "left"].includes(Te(a)), w = o.reference[u] - o.floating[x] + (_ && (($ = i.offset) == null ? void 0 : $[u]) || 0) + (_ ? 0 : b.crossAxis), E = o.reference[u] + o.reference[x] + (_ ? 0 : ((y = i.offset) == null ? void 0 : y[u]) || 0) - (_ ? b.crossAxis : 0);
        m < w ? m = w : m > E && (m = E);
      }
      return {
        [p]: d,
        [u]: m
      };
    }
  };
}, Hc = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: a,
        elements: o
      } = t, {
        apply: i = () => {
        },
        ...s
      } = Ae(e, t), c = await Rt(t, s), l = Te(n), v = gt(n), u = mt(n) === "y", {
        width: p,
        height: d
      } = r.floating;
      let m, h;
      l === "top" || l === "bottom" ? (m = l, h = v === (await (a.isRTL == null ? void 0 : a.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = v === "end" ? "top" : "bottom");
      const b = d - c[m], $ = p - c[h], y = !t.middlewareData.shift;
      let x = b, _ = $;
      if (u) {
        const E = p - c.left - c.right;
        _ = v || y ? Ve($, E) : E;
      } else {
        const E = d - c.top - c.bottom;
        x = v || y ? Ve(b, E) : E;
      }
      if (y && !v) {
        const E = ue(c.left, 0), O = ue(c.right, 0), S = ue(c.top, 0), A = ue(c.bottom, 0);
        u ? _ = p - 2 * (E !== 0 || O !== 0 ? E + O : ue(c.left, c.right)) : x = d - 2 * (S !== 0 || A !== 0 ? S + A : ue(c.top, c.bottom));
      }
      await i({
        ...t,
        availableWidth: _,
        availableHeight: x
      });
      const w = await a.getDimensions(o.floating);
      return p !== w.width || d !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ue(e) {
  return ko(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function fe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ie(e) {
  var t;
  return (t = (ko(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ko(e) {
  return e instanceof Node || e instanceof fe(e).Node;
}
function Re(e) {
  return e instanceof Element || e instanceof fe(e).Element;
}
function Ce(e) {
  return e instanceof HTMLElement || e instanceof fe(e).HTMLElement;
}
function ma(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof fe(e).ShadowRoot;
}
function Nt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = ve(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function Wc(e) {
  return ["table", "td", "th"].includes(Ue(e));
}
function Pr(e) {
  const t = Sr(), n = ve(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function zc(e) {
  let t = vt(e);
  for (; Ce(t) && !mn(t); ) {
    if (Pr(t))
      return t;
    t = vt(t);
  }
  return null;
}
function Sr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function mn(e) {
  return ["html", "body", "#document"].includes(Ue(e));
}
function ve(e) {
  return fe(e).getComputedStyle(e);
}
function bn(e) {
  return Re(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function vt(e) {
  if (Ue(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ma(e) && e.host || // Fallback.
    Ie(e)
  );
  return ma(t) ? t.host : t;
}
function Vo(e) {
  const t = vt(e);
  return mn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ce(t) && Nt(t) ? t : Vo(t);
}
function un(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = Vo(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = fe(r);
  return a ? t.concat(o, o.visualViewport || [], Nt(r) ? r : []) : t.concat(r, un(r));
}
function Bo(e) {
  const t = ve(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = Ce(e), o = a ? e.offsetWidth : n, i = a ? e.offsetHeight : r, s = sn(n) !== o || sn(r) !== i;
  return s && (n = o, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function Or(e) {
  return Re(e) ? e : e.contextElement;
}
function ft(e) {
  const t = Or(e);
  if (!Ce(t))
    return Be(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: o
  } = Bo(t);
  let i = (o ? sn(n.width) : n.width) / r, s = (o ? sn(n.height) : n.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const Gc = /* @__PURE__ */ Be(0);
function Uo(e) {
  const t = fe(e);
  return !Sr() || !t.visualViewport ? Gc : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Kc(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== fe(e) ? !1 : t;
}
function Ye(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), o = Or(e);
  let i = Be(1);
  t && (r ? Re(r) && (i = ft(r)) : i = ft(e));
  const s = Kc(o, n, r) ? Uo(o) : Be(0);
  let c = (a.left + s.x) / i.x, l = (a.top + s.y) / i.y, v = a.width / i.x, u = a.height / i.y;
  if (o) {
    const p = fe(o), d = r && Re(r) ? fe(r) : r;
    let m = p.frameElement;
    for (; m && r && d !== p; ) {
      const h = ft(m), b = m.getBoundingClientRect(), $ = ve(m), y = b.left + (m.clientLeft + parseFloat($.paddingLeft)) * h.x, x = b.top + (m.clientTop + parseFloat($.paddingTop)) * h.y;
      c *= h.x, l *= h.y, v *= h.x, u *= h.y, c += y, l += x, m = fe(m).frameElement;
    }
  }
  return ln({
    width: v,
    height: u,
    x: c,
    y: l
  });
}
function Yc(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const a = Ce(n), o = Ie(n);
  if (n === o)
    return t;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Be(1);
  const c = Be(0);
  if ((a || !a && r !== "fixed") && ((Ue(n) !== "body" || Nt(o)) && (i = bn(n)), Ce(n))) {
    const l = Ye(n);
    s = ft(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - i.scrollLeft * s.x + c.x,
    y: t.y * s.y - i.scrollTop * s.y + c.y
  };
}
function qc(e) {
  return Array.from(e.getClientRects());
}
function Ho(e) {
  return Ye(Ie(e)).left + bn(e).scrollLeft;
}
function Xc(e) {
  const t = Ie(e), n = bn(e), r = e.ownerDocument.body, a = ue(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = ue(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + Ho(e);
  const s = -n.scrollTop;
  return ve(r).direction === "rtl" && (i += ue(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: o,
    x: i,
    y: s
  };
}
function Zc(e, t) {
  const n = fe(e), r = Ie(e), a = n.visualViewport;
  let o = r.clientWidth, i = r.clientHeight, s = 0, c = 0;
  if (a) {
    o = a.width, i = a.height;
    const l = Sr();
    (!l || l && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
function Jc(e, t) {
  const n = Ye(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, o = Ce(e) ? ft(e) : Be(1), i = e.clientWidth * o.x, s = e.clientHeight * o.y, c = a * o.x, l = r * o.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function ba(e, t, n) {
  let r;
  if (t === "viewport")
    r = Zc(e, n);
  else if (t === "document")
    r = Xc(Ie(e));
  else if (Re(t))
    r = Jc(t, n);
  else {
    const a = Uo(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return ln(r);
}
function Wo(e, t) {
  const n = vt(e);
  return n === t || !Re(n) || mn(n) ? !1 : ve(n).position === "fixed" || Wo(n, t);
}
function Qc(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = un(e).filter((s) => Re(s) && Ue(s) !== "body"), a = null;
  const o = ve(e).position === "fixed";
  let i = o ? vt(e) : e;
  for (; Re(i) && !mn(i); ) {
    const s = ve(i), c = Pr(i);
    !c && s.position === "fixed" && (a = null), (o ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Nt(i) && !c && Wo(e, i)) ? r = r.filter((v) => v !== i) : a = s, i = vt(i);
  }
  return t.set(e, r), r;
}
function el(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const i = [...n === "clippingAncestors" ? Qc(t, this._c) : [].concat(n), r], s = i[0], c = i.reduce((l, v) => {
    const u = ba(t, v, a);
    return l.top = ue(u.top, l.top), l.right = Ve(u.right, l.right), l.bottom = Ve(u.bottom, l.bottom), l.left = ue(u.left, l.left), l;
  }, ba(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function tl(e) {
  return Bo(e);
}
function nl(e, t, n) {
  const r = Ce(t), a = Ie(t), o = n === "fixed", i = Ye(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Be(0);
  if (r || !r && !o)
    if ((Ue(t) !== "body" || Nt(a)) && (s = bn(t)), r) {
      const l = Ye(t, !0, o, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else a && (c.x = Ho(a));
  return {
    x: i.left + s.scrollLeft - c.x,
    y: i.top + s.scrollTop - c.y,
    width: i.width,
    height: i.height
  };
}
function ya(e, t) {
  return !Ce(e) || ve(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function zo(e, t) {
  const n = fe(e);
  if (!Ce(e))
    return n;
  let r = ya(e, t);
  for (; r && Wc(r) && ve(r).position === "static"; )
    r = ya(r, t);
  return r && (Ue(r) === "html" || Ue(r) === "body" && ve(r).position === "static" && !Pr(r)) ? n : r || zc(e) || n;
}
const rl = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const a = this.getOffsetParent || zo, o = this.getDimensions;
  return {
    reference: nl(t, await a(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await o(n)
    }
  };
};
function al(e) {
  return ve(e).direction === "rtl";
}
const ol = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Yc,
  getDocumentElement: Ie,
  getClippingRect: el,
  getOffsetParent: zo,
  getElementRects: rl,
  getClientRects: qc,
  getDimensions: tl,
  getScale: ft,
  isElement: Re,
  isRTL: al
};
function il(e, t) {
  let n = null, r;
  const a = Ie(e);
  function o() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), o();
    const {
      left: l,
      top: v,
      width: u,
      height: p
    } = e.getBoundingClientRect();
    if (s || t(), !u || !p)
      return;
    const d = zt(v), m = zt(a.clientWidth - (l + u)), h = zt(a.clientHeight - (v + p)), b = zt(l), y = {
      rootMargin: -d + "px " + -m + "px " + -h + "px " + -b + "px",
      threshold: ue(0, Ve(1, c)) || 1
    };
    let x = !0;
    function _(w) {
      const E = w[0].intersectionRatio;
      if (E !== c) {
        if (!x)
          return i();
        E ? i(!1, E) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(_, {
        ...y,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(_, y);
    }
    n.observe(e);
  }
  return i(!0), o;
}
function sl(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Or(e), v = a || o ? [...l ? un(l) : [], ...un(t)] : [];
  v.forEach(($) => {
    a && $.addEventListener("scroll", n, {
      passive: !0
    }), o && $.addEventListener("resize", n);
  });
  const u = l && s ? il(l, n) : null;
  let p = -1, d = null;
  i && (d = new ResizeObserver(($) => {
    let [y] = $;
    y && y.target === l && d && (d.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      d && d.observe(t);
    })), n();
  }), l && !c && d.observe(l), d.observe(t));
  let m, h = c ? Ye(e) : null;
  c && b();
  function b() {
    const $ = Ye(e);
    h && ($.x !== h.x || $.y !== h.y || $.width !== h.width || $.height !== h.height) && n(), h = $, m = requestAnimationFrame(b);
  }
  return n(), () => {
    v.forEach(($) => {
      a && $.removeEventListener("scroll", n), o && $.removeEventListener("resize", n);
    }), u && u(), d && d.disconnect(), d = null, c && cancelAnimationFrame(m);
  };
}
const cl = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: ol,
    ...n
  }, o = {
    ...a.platform,
    _c: r
  };
  return Nc(e, t, {
    ...a,
    platform: o
  });
}, ll = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? va({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? va({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
};
var en = typeof document < "u" ? br : ne;
function fn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!fn(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = a[r];
      if (!(o === "_owner" && e.$$typeof) && !fn(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Go(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function $a(e, t) {
  const n = Go(e);
  return Math.round(t * n) / n;
}
function xa(e) {
  const t = T.useRef(e);
  return en(() => {
    t.current = e;
  }), t;
}
function ul(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [v, u] = T.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, d] = T.useState(r);
  fn(p, r) || d(r);
  const [m, h] = T.useState(null), [b, $] = T.useState(null), y = T.useCallback((M) => {
    M != E.current && (E.current = M, h(M));
  }, [h]), x = T.useCallback((M) => {
    M !== O.current && (O.current = M, $(M));
  }, [$]), _ = o || m, w = i || b, E = T.useRef(null), O = T.useRef(null), S = T.useRef(v), A = xa(c), U = xa(a), j = T.useCallback(() => {
    if (!E.current || !O.current)
      return;
    const M = {
      placement: t,
      strategy: n,
      middleware: p
    };
    U.current && (M.platform = U.current), cl(E.current, O.current, M).then((ae) => {
      const F = {
        ...ae,
        isPositioned: !0
      };
      z.current && !fn(S.current, F) && (S.current = F, Ds.flushSync(() => {
        u(F);
      }));
    });
  }, [p, t, n, U]);
  en(() => {
    l === !1 && S.current.isPositioned && (S.current.isPositioned = !1, u((M) => ({
      ...M,
      isPositioned: !1
    })));
  }, [l]);
  const z = T.useRef(!1);
  en(() => (z.current = !0, () => {
    z.current = !1;
  }), []), en(() => {
    if (_ && (E.current = _), w && (O.current = w), _ && w) {
      if (A.current)
        return A.current(_, w, j);
      j();
    }
  }, [_, w, j, A]);
  const D = T.useMemo(() => ({
    reference: E,
    floating: O,
    setReference: y,
    setFloating: x
  }), [y, x]), I = T.useMemo(() => ({
    reference: _,
    floating: w
  }), [_, w]), Y = T.useMemo(() => {
    const M = {
      position: n,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return M;
    const ae = $a(I.floating, v.x), F = $a(I.floating, v.y);
    return s ? {
      ...M,
      transform: "translate(" + ae + "px, " + F + "px)",
      ...Go(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ae,
      top: F
    };
  }, [n, s, I.floating, v.x, v.y]);
  return T.useMemo(() => ({
    ...v,
    update: j,
    refs: D,
    elements: I,
    floatingStyles: Y
  }), [v, j, D, I, Y]);
}
function fl(e) {
  const [t, n] = Q(void 0);
  return pt(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const o = a[0];
        let i, s;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({
          width: i,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Ko = "Popper", [Yo, qo] = Mo(Ko), [dl, Xo] = Yo(Ko), pl = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = Q(null);
  return /* @__PURE__ */ B(dl, {
    scope: t,
    anchor: r,
    onAnchorChange: a
  }, n);
}, vl = "PopperAnchor", hl = /* @__PURE__ */ de((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...a } = e, o = Xo(vl, n), i = re(null), s = qe(t, i);
  return ne(() => {
    o.onAnchorChange((r == null ? void 0 : r.current) || i.current);
  }), r ? null : /* @__PURE__ */ B(ht.div, oe({}, a, {
    ref: s
  }));
}), Zo = "PopperContent", [gl, z_] = Yo(Zo), ml = /* @__PURE__ */ de((e, t) => {
  var n, r, a, o, i, s, c, l;
  const { __scopePopper: v, side: u = "bottom", sideOffset: p = 0, align: d = "center", alignOffset: m = 0, arrowPadding: h = 0, avoidCollisions: b = !0, collisionBoundary: $ = [], collisionPadding: y = 0, sticky: x = "partial", hideWhenDetached: _ = !1, updatePositionStrategy: w = "optimized", onPlaced: E, ...O } = e, S = Xo(Zo, v), [A, U] = Q(null), j = qe(
    t,
    (_e) => U(_e)
  ), [z, D] = Q(null), I = fl(z), Y = (n = I == null ? void 0 : I.width) !== null && n !== void 0 ? n : 0, M = (r = I == null ? void 0 : I.height) !== null && r !== void 0 ? r : 0, ae = u + (d !== "center" ? "-" + d : ""), F = typeof y == "number" ? y : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...y
  }, X = Array.isArray($) ? $ : [
    $
  ], ie = X.length > 0, $e = {
    padding: F,
    boundary: X.filter(bl),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: ie
  }, { refs: He, floatingStyles: De, placement: et, isPositioned: Pe, middlewareData: le } = ul({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: ae,
    whileElementsMounted: (..._e) => sl(..._e, {
      animationFrame: w === "always"
    }),
    elements: {
      reference: S.anchor
    },
    middleware: [
      Vc({
        mainAxis: p + M,
        alignmentAxis: m
      }),
      b && Bc({
        mainAxis: !0,
        crossAxis: !1,
        limiter: x === "partial" ? Uc() : void 0,
        ...$e
      }),
      b && Fc({
        ...$e
      }),
      Hc({
        ...$e,
        apply: ({ elements: _e, rects: Ne, availableWidth: Ut, availableHeight: Ht }) => {
          const { width: tt, height: Tn } = Ne.reference, nt = _e.floating.style;
          nt.setProperty("--radix-popper-available-width", `${Ut}px`), nt.setProperty("--radix-popper-available-height", `${Ht}px`), nt.setProperty("--radix-popper-anchor-width", `${tt}px`), nt.setProperty("--radix-popper-anchor-height", `${Tn}px`);
        }
      }),
      z && ll({
        element: z,
        padding: h
      }),
      yl({
        arrowWidth: Y,
        arrowHeight: M
      }),
      _ && Lc({
        strategy: "referenceHidden",
        ...$e
      })
    ]
  }), [Se, ge] = Jo(et), xe = ke(E);
  pt(() => {
    Pe && (xe == null || xe());
  }, [
    Pe,
    xe
  ]);
  const Me = (a = le.arrow) === null || a === void 0 ? void 0 : a.x, Sn = (o = le.arrow) === null || o === void 0 ? void 0 : o.y, Bt = ((i = le.arrow) === null || i === void 0 ? void 0 : i.centerOffset) !== 0, [On, An] = Q();
  return pt(() => {
    A && An(window.getComputedStyle(A).zIndex);
  }, [
    A
  ]), /* @__PURE__ */ B("div", {
    ref: He.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...De,
      transform: Pe ? De.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: On,
      "--radix-popper-transform-origin": [
        (s = le.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = le.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ B(gl, {
    scope: v,
    placedSide: Se,
    onArrowChange: D,
    arrowX: Me,
    arrowY: Sn,
    shouldHideArrow: Bt
  }, /* @__PURE__ */ B(ht.div, oe({
    "data-side": Se,
    "data-align": ge
  }, O, {
    ref: j,
    style: {
      ...O.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: Pe ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = le.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function bl(e) {
  return e !== null;
}
const yl = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, a, o, i;
    const { placement: s, rects: c, middlewareData: l } = t, u = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, p = u ? 0 : e.arrowWidth, d = u ? 0 : e.arrowHeight, [m, h] = Jo(s), b = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[h], $ = ((r = (a = l.arrow) === null || a === void 0 ? void 0 : a.x) !== null && r !== void 0 ? r : 0) + p / 2, y = ((o = (i = l.arrow) === null || i === void 0 ? void 0 : i.y) !== null && o !== void 0 ? o : 0) + d / 2;
    let x = "", _ = "";
    return m === "bottom" ? (x = u ? b : `${$}px`, _ = `${-d}px`) : m === "top" ? (x = u ? b : `${$}px`, _ = `${c.floating.height + d}px`) : m === "right" ? (x = `${-d}px`, _ = u ? b : `${y}px`) : m === "left" && (x = `${c.floating.width + d}px`, _ = u ? b : `${y}px`), {
      data: {
        x,
        y: _
      }
    };
  }
});
function Jo(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const $l = pl, xl = hl, _l = ml, wl = /* @__PURE__ */ de((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...a } = e;
  return r ? /* @__PURE__ */ Ms.createPortal(/* @__PURE__ */ B(ht.div, oe({}, a, {
    ref: t
  })), r) : null;
});
function Cl(e, t) {
  return As((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const Ar = (e) => {
  const { present: t, children: n } = e, r = El(t), a = typeof n == "function" ? n({
    present: r.isPresent
  }) : lt.only(n), o = qe(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ gn(a, {
    ref: o
  }) : null;
};
Ar.displayName = "Presence";
function El(e) {
  const [t, n] = Q(), r = re({}), a = re(e), o = re("none"), i = e ? "mounted" : "unmounted", [s, c] = Cl(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ne(() => {
    const l = Gt(r.current);
    o.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), pt(() => {
    const l = r.current, v = a.current;
    if (v !== e) {
      const p = o.current, d = Gt(l);
      e ? c("MOUNT") : d === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(v && p !== d ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), pt(() => {
    if (t) {
      const l = (u) => {
        const d = Gt(r.current).includes(u.animationName);
        u.target === t && d && jo(
          () => c("ANIMATION_END")
        );
      }, v = (u) => {
        u.target === t && (o.current = Gt(r.current));
      };
      return t.addEventListener("animationstart", v), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", v), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: q((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Gt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Pl({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = Sl({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, i = o ? e : r, s = ke(n), c = q((l) => {
    if (o) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else a(l);
  }, [
    o,
    e,
    a,
    s
  ]);
  return [
    i,
    c
  ];
}
function Sl({ defaultProp: e, onChange: t }) {
  const n = Q(e), [r] = n, a = re(r), o = ke(t);
  return ne(() => {
    a.current !== r && (o(r), a.current = r);
  }, [
    r,
    a,
    o
  ]), n;
}
var Ol = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ot = /* @__PURE__ */ new WeakMap(), Kt = /* @__PURE__ */ new WeakMap(), Yt = {}, Bn = 0, Qo = function(e) {
  return e && (e.host || Qo(e.parentNode));
}, Al = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Qo(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Tl = function(e, t, n, r) {
  var a = Al(t, Array.isArray(e) ? e : [e]);
  Yt[n] || (Yt[n] = /* @__PURE__ */ new WeakMap());
  var o = Yt[n], i = [], s = /* @__PURE__ */ new Set(), c = new Set(a), l = function(u) {
    !u || s.has(u) || (s.add(u), l(u.parentNode));
  };
  a.forEach(l);
  var v = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(p) {
      if (s.has(p))
        v(p);
      else {
        var d = p.getAttribute(r), m = d !== null && d !== "false", h = (ot.get(p) || 0) + 1, b = (o.get(p) || 0) + 1;
        ot.set(p, h), o.set(p, b), i.push(p), h === 1 && m && Kt.set(p, !0), b === 1 && p.setAttribute(n, "true"), m || p.setAttribute(r, "true");
      }
    });
  };
  return v(t), s.clear(), Bn++, function() {
    i.forEach(function(u) {
      var p = ot.get(u) - 1, d = o.get(u) - 1;
      ot.set(u, p), o.set(u, d), p || (Kt.has(u) || u.removeAttribute(r), Kt.delete(u)), d || u.removeAttribute(n);
    }), Bn--, Bn || (ot = /* @__PURE__ */ new WeakMap(), ot = /* @__PURE__ */ new WeakMap(), Kt = /* @__PURE__ */ new WeakMap(), Yt = {});
  };
}, Rl = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), a = Ol(e);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live]"))), Tl(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, we = function() {
  return we = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, we.apply(this, arguments);
};
function ei(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function jl(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, o; r < a; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var tn = "right-scroll-bar-position", nn = "width-before-scroll-bar", Il = "with-scroll-bars-hidden", Dl = "--removed-body-scroll-bar-size";
function Ml(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Nl(e, t) {
  var n = Q(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function Fl(e, t) {
  return Nl(null, function(n) {
    return e.forEach(function(r) {
      return Ml(r, n);
    });
  });
}
function Ll(e) {
  return e;
}
function kl(e, t) {
  t === void 0 && (t = Ll);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var i = t(o, r);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), i = n;
      }
      var c = function() {
        var v = i;
        i = [], v.forEach(o);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(v) {
          i.push(v), l();
        },
        filter: function(v) {
          return i = i.filter(v), n;
        }
      };
    }
  };
  return a;
}
function Vl(e) {
  e === void 0 && (e = {});
  var t = kl(null);
  return t.options = we({ async: !0, ssr: !1 }, e), t;
}
var ti = function(e) {
  var t = e.sideCar, n = ei(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return T.createElement(r, we({}, n));
};
ti.isSideCarExport = !0;
function Bl(e, t) {
  return e.useMedium(t), ti;
}
var ni = Vl(), Un = function() {
}, yn = T.forwardRef(function(e, t) {
  var n = T.useRef(null), r = T.useState({
    onScrollCapture: Un,
    onWheelCapture: Un,
    onTouchMoveCapture: Un
  }), a = r[0], o = r[1], i = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, v = e.enabled, u = e.shards, p = e.sideCar, d = e.noIsolation, m = e.inert, h = e.allowPinchZoom, b = e.as, $ = b === void 0 ? "div" : b, y = ei(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), x = p, _ = Fl([n, t]), w = we(we({}, y), a);
  return T.createElement(
    T.Fragment,
    null,
    v && T.createElement(x, { sideCar: ni, removeScrollBar: l, shards: u, noIsolation: d, inert: m, setCallbacks: o, allowPinchZoom: !!h, lockRef: n }),
    i ? T.cloneElement(T.Children.only(s), we(we({}, w), { ref: _ })) : T.createElement($, we({}, w, { className: c, ref: _ }), s)
  );
});
yn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
yn.classNames = {
  fullWidth: nn,
  zeroRight: tn
};
var Ul = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Hl() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ul();
  return t && e.setAttribute("nonce", t), e;
}
function Wl(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function zl(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Gl = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Hl()) && (Wl(t, n), zl(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Kl = function() {
  var e = Gl();
  return function(t, n) {
    T.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, ri = function() {
  var e = Kl(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, Yl = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Hn = function(e) {
  return parseInt(e || "", 10) || 0;
}, ql = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Hn(n), Hn(r), Hn(a)];
}, Xl = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Yl;
  var t = ql(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Zl = ri(), Jl = function(e, t, n, r) {
  var a = e.left, o = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Il, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(tn, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(nn, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(tn, " .").concat(tn, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(nn, " .").concat(nn, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(Dl, ": ").concat(s, `px;
  }
`);
}, Ql = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r, o = T.useMemo(function() {
    return Xl(a);
  }, [a]);
  return T.createElement(Zl, { styles: Jl(o, !t, a, n ? "" : "!important") });
}, ar = !1;
if (typeof window < "u")
  try {
    var qt = Object.defineProperty({}, "passive", {
      get: function() {
        return ar = !0, !0;
      }
    });
    window.addEventListener("test", qt, qt), window.removeEventListener("test", qt, qt);
  } catch {
    ar = !1;
  }
var it = ar ? { passive: !1 } : !1, eu = function(e) {
  return e.tagName === "TEXTAREA";
}, ai = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !eu(e) && n[t] === "visible")
  );
}, tu = function(e) {
  return ai(e, "overflowY");
}, nu = function(e) {
  return ai(e, "overflowX");
}, _a = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = oi(e, n);
    if (r) {
      var a = ii(e, n), o = a[1], i = a[2];
      if (o > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, ru = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, au = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, oi = function(e, t) {
  return e === "v" ? tu(t) : nu(t);
}, ii = function(e, t) {
  return e === "v" ? ru(t) : au(t);
}, ou = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, iu = function(e, t, n, r, a) {
  var o = ou(e, window.getComputedStyle(t).direction), i = o * r, s = n.target, c = t.contains(s), l = !1, v = i > 0, u = 0, p = 0;
  do {
    var d = ii(e, s), m = d[0], h = d[1], b = d[2], $ = h - b - o * m;
    (m || $) && oi(e, s) && (u += $, p += m), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (v && (u === 0 || !a) || !v && (p === 0 || !a)) && (l = !0), l;
}, Xt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, wa = function(e) {
  return [e.deltaX, e.deltaY];
}, Ca = function(e) {
  return e && "current" in e ? e.current : e;
}, su = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, cu = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, lu = 0, st = [];
function uu(e) {
  var t = T.useRef([]), n = T.useRef([0, 0]), r = T.useRef(), a = T.useState(lu++)[0], o = T.useState(function() {
    return ri();
  })[0], i = T.useRef(e);
  T.useEffect(function() {
    i.current = e;
  }, [e]), T.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var h = jl([e.lockRef.current], (e.shards || []).map(Ca), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = T.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2)
      return !i.current.allowPinchZoom;
    var $ = Xt(h), y = n.current, x = "deltaX" in h ? h.deltaX : y[0] - $[0], _ = "deltaY" in h ? h.deltaY : y[1] - $[1], w, E = h.target, O = Math.abs(x) > Math.abs(_) ? "h" : "v";
    if ("touches" in h && O === "h" && E.type === "range")
      return !1;
    var S = _a(O, E);
    if (!S)
      return !0;
    if (S ? w = O : (w = O === "v" ? "h" : "v", S = _a(O, E)), !S)
      return !1;
    if (!r.current && "changedTouches" in h && (x || _) && (r.current = w), !w)
      return !0;
    var A = r.current || w;
    return iu(A, b, h, A === "h" ? x : _, !0);
  }, []), c = T.useCallback(function(h) {
    var b = h;
    if (!(!st.length || st[st.length - 1] !== o)) {
      var $ = "deltaY" in b ? wa(b) : Xt(b), y = t.current.filter(function(w) {
        return w.name === b.type && w.target === b.target && su(w.delta, $);
      })[0];
      if (y && y.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!y) {
        var x = (i.current.shards || []).map(Ca).filter(Boolean).filter(function(w) {
          return w.contains(b.target);
        }), _ = x.length > 0 ? s(b, x[0]) : !i.current.noIsolation;
        _ && b.cancelable && b.preventDefault();
      }
    }
  }, []), l = T.useCallback(function(h, b, $, y) {
    var x = { name: h, delta: b, target: $, should: y };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== x;
      });
    }, 1);
  }, []), v = T.useCallback(function(h) {
    n.current = Xt(h), r.current = void 0;
  }, []), u = T.useCallback(function(h) {
    l(h.type, wa(h), h.target, s(h, e.lockRef.current));
  }, []), p = T.useCallback(function(h) {
    l(h.type, Xt(h), h.target, s(h, e.lockRef.current));
  }, []);
  T.useEffect(function() {
    return st.push(o), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", c, it), document.addEventListener("touchmove", c, it), document.addEventListener("touchstart", v, it), function() {
      st = st.filter(function(h) {
        return h !== o;
      }), document.removeEventListener("wheel", c, it), document.removeEventListener("touchmove", c, it), document.removeEventListener("touchstart", v, it);
    };
  }, []);
  var d = e.removeScrollBar, m = e.inert;
  return T.createElement(
    T.Fragment,
    null,
    m ? T.createElement(o, { styles: cu(a) }) : null,
    d ? T.createElement(Ql, { gapMode: "margin" }) : null
  );
}
const fu = Bl(ni, uu);
var si = T.forwardRef(function(e, t) {
  return T.createElement(yn, we({}, e, { ref: t, sideCar: fu }));
});
si.classNames = yn.classNames;
const ci = "Popover", [li, G_] = Mo(ci, [
  qo
]), Tr = qo(), [du, bt] = li(ci), pu = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: a, onOpenChange: o, modal: i = !1 } = e, s = Tr(t), c = re(null), [l, v] = Q(!1), [u = !1, p] = Pl({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ B($l, s, /* @__PURE__ */ B(du, {
    scope: t,
    contentId: Sc(),
    triggerRef: c,
    open: u,
    onOpenChange: p,
    onOpenToggle: q(
      () => p(
        (d) => !d
      ),
      [
        p
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: q(
      () => v(!0),
      []
    ),
    onCustomAnchorRemove: q(
      () => v(!1),
      []
    ),
    modal: i
  }, n));
}, vu = "PopoverTrigger", hu = /* @__PURE__ */ de((e, t) => {
  const { __scopePopover: n, ...r } = e, a = bt(vu, n), o = Tr(n), i = qe(t, a.triggerRef), s = /* @__PURE__ */ B(ht.button, oe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": di(a.open)
  }, r, {
    ref: i,
    onClick: Ge(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ B(xl, oe({
    asChild: !0
  }, o), s);
}), ui = "PopoverPortal", [gu, mu] = li(ui, {
  forceMount: void 0
}), bu = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: a } = e, o = bt(ui, t);
  return /* @__PURE__ */ B(gu, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ B(Ar, {
    present: n || o.open
  }, /* @__PURE__ */ B(wl, {
    asChild: !0,
    container: a
  }, r)));
}, jt = "PopoverContent", yu = /* @__PURE__ */ de((e, t) => {
  const n = mu(jt, e.__scopePopover), { forceMount: r = n.forceMount, ...a } = e, o = bt(jt, e.__scopePopover);
  return /* @__PURE__ */ B(Ar, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ B($u, oe({}, a, {
    ref: t
  })) : /* @__PURE__ */ B(xu, oe({}, a, {
    ref: t
  })));
}), $u = /* @__PURE__ */ de((e, t) => {
  const n = bt(jt, e.__scopePopover), r = re(null), a = qe(t, r), o = re(!1);
  return ne(() => {
    const i = r.current;
    if (i) return Rl(i);
  }, []), /* @__PURE__ */ B(si, {
    as: _r,
    allowPinchZoom: !0
  }, /* @__PURE__ */ B(fi, oe({}, e, {
    ref: a,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Ge(e.onCloseAutoFocus, (i) => {
      var s;
      i.preventDefault(), o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Ge(e.onPointerDownOutside, (i) => {
      const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
      o.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Ge(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), xu = /* @__PURE__ */ de((e, t) => {
  const n = bt(jt, e.__scopePopover), r = re(!1), a = re(!1);
  return /* @__PURE__ */ B(fi, oe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, a.current = !1;
    },
    onInteractOutside: (o) => {
      var i, s;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && a.current && o.preventDefault();
    }
  }));
}), fi = /* @__PURE__ */ de((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: o, disableOutsidePointerEvents: i, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: v, ...u } = e, p = bt(jt, n), d = Tr(n);
  return mc(), /* @__PURE__ */ B(bc, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: a,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ B(vc, {
    asChild: !0,
    disableOutsidePointerEvents: i,
    onInteractOutside: v,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => p.onOpenChange(!1)
  }, /* @__PURE__ */ B(_l, oe({
    "data-state": di(p.open),
    role: "dialog",
    id: p.contentId
  }, d, u, {
    ref: t,
    style: {
      ...u.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function di(e) {
  return e ? "open" : "closed";
}
const pi = pu, vi = hu, hi = bu, gi = yu, _u = "_tooltip_13k1h_27", wu = "_popover_13k1h_31", Ea = {
  tooltip: _u,
  popover: wu
}, K_ = ({
  actions: e,
  buttonProps: t = {},
  side: n = "bottom",
  align: r = "end"
}) => {
  const [a, o] = Q(!1);
  if (!e.length) return null;
  const i = (s, c) => {
    switch (s.type) {
      case "button":
      case "link": {
        const l = /* @__PURE__ */ g.jsx(
          Fn.Item,
          {
            icon: s.icon,
            onClick: () => {
              var v;
              (v = s.onClick) == null || v.call(s), o(!1);
            },
            isDisabled: s.disabled ?? !1,
            children: /* @__PURE__ */ g.jsxs(
              K,
              {
                as: "span",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                children: [
                  /* @__PURE__ */ g.jsx("span", { children: s.label }),
                  s.description && /* @__PURE__ */ g.jsx(W.Paragraph, { as: "span", variant: "4", subdued: !0, children: s.description })
                ]
              }
            )
          }
        );
        return /* @__PURE__ */ g.jsx(
          Dt,
          {
            className: Ea.tooltip,
            content: s.tooltip,
            children: s.type === "link" ? gn(s.link, {
              children: l
            }) : l
          },
          c
        );
      }
      case "divider":
        return /* @__PURE__ */ g.jsx(Fn.Divider, {}, c);
      default:
        return null;
    }
  };
  return /* @__PURE__ */ g.jsxs(pi, { open: a, onOpenChange: o, children: [
    /* @__PURE__ */ g.jsx(vi, { asChild: !0, children: /* @__PURE__ */ g.jsx("div", { children: /* @__PURE__ */ g.jsx(yr, { variant: "tertiary", icon: "dots-v", ...t }) }) }),
    /* @__PURE__ */ g.jsx(hi, { children: /* @__PURE__ */ g.jsx(
      gi,
      {
        className: Ea.popover,
        side: n,
        align: r,
        sideOffset: parseInt(xr.spacer[200]),
        onOpenAutoFocus: (s) => s.preventDefault(),
        children: /* @__PURE__ */ g.jsx(Fn, { children: e.map((s, c) => i(s, c)) })
      }
    ) })
  ] });
};
var Rr = {}, or = function() {
  return (or = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var a in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }).apply(this, arguments);
}, Cu = function() {
  function e(t, n, r) {
    var a = this;
    this.endVal = n, this.options = r, this.version = "2.6.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(o) {
      a.startTime || (a.startTime = o);
      var i = o - a.startTime;
      a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
      var s = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = s ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(o) {
      var i, s, c, l, v = o < 0 ? "-" : "";
      i = Math.abs(o).toFixed(a.options.decimalPlaces);
      var u = (i += "").split(".");
      if (s = u[0], c = u.length > 1 ? a.options.decimal + u[1] : "", a.options.useGrouping) {
        l = "";
        for (var p = 3, d = 0, m = 0, h = s.length; m < h; ++m) a.options.useIndianSeparators && m === 4 && (p = 2, d = 1), m !== 0 && d % p == 0 && (l = a.options.separator + l), d++, l = s[h - m - 1] + l;
        s = l;
      }
      return a.options.numerals && a.options.numerals.length && (s = s.replace(/[0-9]/g, function(b) {
        return a.options.numerals[+b];
      }), c = c.replace(/[0-9]/g, function(b) {
        return a.options.numerals[+b];
      })), v + a.options.prefix + s + c + a.options.suffix;
    }, this.easeOutExpo = function(o, i, s, c) {
      return s * (1 - Math.pow(2, -10 * o / c)) * 1024 / 1023 + i;
    }, this.options = or(or({}, this.defaults), r), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof t == "string" ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(o) {
        return o();
      });
    }, this.handleScroll(this)));
  }
  return e.prototype.handleScroll = function(t) {
    if (t && window && !t.once) {
      var n = window.innerHeight + window.scrollY, r = t.el.getBoundingClientRect(), a = r.top + window.pageYOffset, o = r.top + r.height + window.pageYOffset;
      o < n && o > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
        return t.start();
      }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > o || a > n) && !t.paused && t.reset();
    }
  }, e.prototype.determineDirectionAndSmartEasing = function() {
    var t = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > t;
    var n = t - this.startVal;
    if (Math.abs(n) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = t;
      var r = this.countDown ? 1 : -1;
      this.endVal = t + r * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = t, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, e.prototype.start = function(t) {
    this.error || (t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, e.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, e.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, e.prototype.update = function(t) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, e.prototype.printValue = function(t) {
    var n;
    if (this.el) {
      var r = this.formattingFn(t);
      (n = this.options.plugin) !== null && n !== void 0 && n.render ? this.options.plugin.render(this.el, r) : this.el.tagName === "INPUT" ? this.el.value = r : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = r : this.el.innerHTML = r;
    }
  }, e.prototype.ensureNumber = function(t) {
    return typeof t == "number" && !isNaN(t);
  }, e.prototype.validateValue = function(t) {
    var n = Number(t);
    return this.ensureNumber(n) ? n : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
  }, e.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, e;
}();
const Eu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: Cu
}, Symbol.toStringTag, { value: "Module" })), Pu = /* @__PURE__ */ ec(Eu);
Object.defineProperty(Rr, "__esModule", { value: !0 });
var te = mr, Su = Pu;
function Ou(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (v) {
      l = !0, a = v;
    } finally {
      try {
        if (!c && n.return != null && (i = n.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function Pa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pa(Object(n), !0).forEach(function(r) {
      Au(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pa(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Au(e, t, n) {
  return t = Nu(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ir() {
  return ir = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ir.apply(this, arguments);
}
function Tu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function mi(e, t) {
  if (e == null) return {};
  var n = Tu(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Ru(e, t) {
  return ju(e) || Ou(e, t) || Iu(e, t) || Du();
}
function ju(e) {
  if (Array.isArray(e)) return e;
}
function Iu(e, t) {
  if (e) {
    if (typeof e == "string") return Sa(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sa(e, t);
  }
}
function Sa(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Du() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mu(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Nu(e) {
  var t = Mu(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Fu = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? te.useLayoutEffect : te.useEffect;
function be(e) {
  var t = te.useRef(e);
  return Fu(function() {
    t.current = e;
  }), te.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return t.current.apply(void 0, r);
  }, []);
}
var Lu = function(t, n) {
  var r = n.decimal, a = n.decimals, o = n.duration, i = n.easingFn, s = n.end, c = n.formattingFn, l = n.numerals, v = n.prefix, u = n.separator, p = n.start, d = n.suffix, m = n.useEasing, h = n.useGrouping, b = n.useIndianSeparators, $ = n.enableScrollSpy, y = n.scrollSpyDelay, x = n.scrollSpyOnce;
  return new Su.CountUp(t, s, {
    startVal: p,
    duration: o,
    decimal: r,
    decimalPlaces: a,
    easingFn: i,
    formattingFn: c,
    numerals: l,
    separator: u,
    prefix: v,
    suffix: d,
    useEasing: m,
    useIndianSeparators: b,
    useGrouping: h,
    enableScrollSpy: $,
    scrollSpyDelay: y,
    scrollSpyOnce: x
  });
}, ku = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], Vu = {
  decimal: ".",
  separator: ",",
  delay: null,
  prefix: "",
  suffix: "",
  duration: 2,
  start: 0,
  decimals: 0,
  startOnMount: !0,
  enableReinitialize: !0,
  useEasing: !0,
  useGrouping: !0,
  useIndianSeparators: !1
}, bi = function(t) {
  var n = Object.fromEntries(Object.entries(t).filter(function(A) {
    var U = Ru(A, 2), j = U[1];
    return j !== void 0;
  })), r = te.useMemo(function() {
    return dn(dn({}, Vu), n);
  }, [t]), a = r.ref, o = r.startOnMount, i = r.enableReinitialize, s = r.delay, c = r.onEnd, l = r.onStart, v = r.onPauseResume, u = r.onReset, p = r.onUpdate, d = mi(r, ku), m = te.useRef(), h = te.useRef(), b = te.useRef(!1), $ = be(function() {
    return Lu(typeof a == "string" ? a : a.current, d);
  }), y = be(function(A) {
    var U = m.current;
    if (U && !A)
      return U;
    var j = $();
    return m.current = j, j;
  }), x = be(function() {
    var A = function() {
      return y(!0).start(function() {
        c == null || c({
          pauseResume: _,
          reset: w,
          start: O,
          update: E
        });
      });
    };
    s && s > 0 ? h.current = setTimeout(A, s * 1e3) : A(), l == null || l({
      pauseResume: _,
      reset: w,
      update: E
    });
  }), _ = be(function() {
    y().pauseResume(), v == null || v({
      reset: w,
      start: O,
      update: E
    });
  }), w = be(function() {
    y().el && (h.current && clearTimeout(h.current), y().reset(), u == null || u({
      pauseResume: _,
      start: O,
      update: E
    }));
  }), E = be(function(A) {
    y().update(A), p == null || p({
      pauseResume: _,
      reset: w,
      start: O
    });
  }), O = be(function() {
    w(), x();
  }), S = be(function(A) {
    o && (A && w(), x());
  });
  return te.useEffect(function() {
    b.current ? i && S(!0) : (b.current = !0, S());
  }, [i, b, S, s, t.start, t.suffix, t.prefix, t.duration, t.separator, t.decimals, t.decimal, t.formattingFn]), te.useEffect(function() {
    return function() {
      w();
    };
  }, [w]), {
    start: O,
    pauseResume: _,
    reset: w,
    update: E,
    getCountUp: y
  };
}, Bu = ["className", "redraw", "containerProps", "children", "style"], Uu = function(t) {
  var n = t.className, r = t.redraw, a = t.containerProps, o = t.children, i = t.style, s = mi(t, Bu), c = te.useRef(null), l = te.useRef(!1), v = bi(dn(dn({}, s), {}, {
    ref: c,
    startOnMount: typeof o != "function" || t.delay === 0,
    // component manually restarts
    enableReinitialize: !1
  })), u = v.start, p = v.reset, d = v.update, m = v.pauseResume, h = v.getCountUp, b = be(function() {
    u();
  }), $ = be(function(_) {
    t.preserveValue || p(), d(_);
  }), y = be(function() {
    if (typeof t.children == "function" && !(c.current instanceof Element)) {
      console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
      return;
    }
    h();
  });
  te.useEffect(function() {
    y();
  }, [y]), te.useEffect(function() {
    l.current && $(t.end);
  }, [t.end, $]);
  var x = r && t;
  return te.useEffect(function() {
    r && l.current && b();
  }, [b, r, x]), te.useEffect(function() {
    !r && l.current && b();
  }, [b, r, t.start, t.suffix, t.prefix, t.duration, t.separator, t.decimals, t.decimal, t.className, t.formattingFn]), te.useEffect(function() {
    l.current = !0;
  }, []), typeof o == "function" ? o({
    countUpRef: c,
    start: u,
    reset: p,
    update: d,
    pauseResume: m,
    getCountUp: h
  }) : /* @__PURE__ */ te.createElement("span", ir({
    className: n,
    ref: c,
    style: i
  }, a), typeof t.start < "u" ? h().formattingFn(t.start) : "");
}, Hu = Rr.default = Uu;
Rr.useCountUp = bi;
const Wu = "_bar_12q02_27", zu = "_section_12q02_31", Gu = "_sectionHidden_12q02_34", Ku = "_sectionInheritRadius_12q02_37", Yu = "_valueOutside_12q02_41", ct = {
  bar: Wu,
  section: zu,
  sectionHidden: Gu,
  sectionInheritRadius: Ku,
  valueOutside: Yu
}, rn = ({
  value: e,
  label: t,
  labelWidth: n,
  theme: r = [k.purple[700], k.neutral[200]],
  showFullBar: a = !1,
  showDifference: o = !1
}) => {
  const i = Math.min(e, 100), [s, c] = Q([
    null,
    null
  ]), l = Io(s);
  ne(() => {
    c([
      i,
      ...a ? [100 - i] : []
    ]);
  }, [i, a]);
  const v = 1.5, u = J(
    () => s.map((p, d) => {
      const m = i && d === 0 || o, h = p !== null && p < 20, b = Oe(ct.section, {
        [ct.sectionHidden]: a && p === 0,
        [ct.sectionInheritRadius]: !a
      }), $ = Oe(ct.section, {
        [ct.valueOutside]: h
      });
      return /* @__PURE__ */ g.jsx(
        K,
        {
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 100",
          background: r[d],
          color: "neutral.000",
          className: b,
          style: {
            flexBasis: `${p ?? 0}%`,
            transition: `flex-basis ${v}s ease-out`
          },
          children: m && /* @__PURE__ */ g.jsx(
            W.Paragraph,
            {
              className: $,
              variant: "4",
              color: d === 0 && !h ? k.neutral["000"] : k.neutral[900],
              children: /* @__PURE__ */ g.jsx(
                Hu,
                {
                  start: (l == null ? void 0 : l[d]) ?? 0,
                  end: p ?? 0,
                  duration: v,
                  delay: 0,
                  suffix: "%",
                  children: ({ countUpRef: y }) => /* @__PURE__ */ g.jsx("span", { ref: y })
                }
              )
            }
          )
        },
        d
      );
    }),
    [
      i,
      r,
      o,
      a,
      s,
      l
    ]
  );
  return /* @__PURE__ */ g.jsxs(K, { alignItems: "center", gap: "200", children: [
    t && /* @__PURE__ */ g.jsx($r, { minWidth: n ? `${n}px` : "auto", children: /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "4", children: t }) }),
    /* @__PURE__ */ g.jsx(K, { flex: "1", className: ct.bar, height: "20px", borderRadius: "50", children: u })
  ] });
}, qu = "_container_1t2a7_1", Xu = {
  container: qu
}, Zu = he(
  function({
    granularities: t,
    onChangeGranularity: n
  }) {
    return /* @__PURE__ */ g.jsx(Ao, { variant: "secondary", children: t.map(({ value: r, selected: a }) => /* @__PURE__ */ g.jsx(
      To,
      {
        onClick: a ? void 0 : () => n == null ? void 0 : n(r),
        active: a,
        children: r
      },
      r
    )) });
  }
), Ju = "_root_l5gsy_27", Qu = "_rootBounded_l5gsy_33", ef = "_rootFluid_l5gsy_33", Wn = {
  root: Ju,
  rootBounded: Qu,
  rootFluid: ef
}, sr = ({
  bounded: e = !1,
  fluid: t = !1,
  children: n
}) => {
  const r = Oe(Wn.root, {
    [Wn.rootBounded]: e,
    [Wn.rootFluid]: t
  });
  return /* @__PURE__ */ g.jsx("div", { className: r, children: n });
};
function Ke(e, t = { compact: !1 }) {
  if (e < 1e3)
    return `${(e / 1e3).toFixed(0)}s`;
  const n = Math.floor(e / 1e3 % 60), r = Math.floor(e / (1e3 * 60) % 60), a = Math.floor(e / (1e3 * 60 * 60) % 24), o = Math.floor(e / (1e3 * 60 * 60 * 24)), i = (c, l) => c > 0 ? `${c}${l}` : "";
  return [
    i(o, "d"),
    i(a, "h"),
    i(r, "m") || (t.compact ? "" : "0m"),
    i(n, "s") || (t.compact ? "" : "0s")
  ].filter(Boolean).join(" ");
}
const Oa = 1e6, Aa = 1e3;
function yi(e) {
  if (e < Aa) return `${e}`;
  const t = e >= Oa;
  return `${parseFloat(
    (e / (t ? Oa : Aa)).toFixed(1)
  )}${t ? "M" : "K"}`;
}
function It(e) {
  return e.toLocaleString(navigator.language);
}
const Y_ = (e) => ({
  metrics: e.filter(tf),
  chart: e.find(nf),
  heatmap: e.find(rf),
  table: e.find(af),
  presence: e.find(of)
}), tf = (e) => e.type === "metric", nf = (e) => e.type === "chart" && e.visualization !== "heatmap", rf = (e) => e.type === "chart" && e.visualization === "heatmap", af = (e) => e.type === "table", of = (e) => e.type === "presence", q_ = (e) => e.type === "ai_insight", Ft = (e, t) => {
  switch (t) {
    case "duration":
      return Ke(e).split(" ").slice(0, 2).join(" ");
    case "count":
      return yi(e);
    case "number":
      return It(e);
    case "percentage":
      return `${It(e)}%`;
    case "timer":
      return Ke(e);
    default:
      return "";
  }
}, jr = [
  {
    name: "default",
    colors: [
      k.purple[700],
      k.blue[300],
      k.red[500],
      k.orange[300],
      k.purple[500],
      k.green[400],
      k.neutral[600],
      k.neutral[300]
    ]
  },
  {
    name: "rating",
    colors: [
      k.red[700],
      k.red[400],
      k.orange[300],
      k.green[500],
      k.green[600]
    ]
  }
], $i = jr[0], sf = (e) => e.startsWith("#"), xi = (e) => {
  var a;
  if (sf(e)) return e;
  const [t, n] = e.split("-"), r = jr.find((o) => o.name === t) ?? $i;
  return ((a = r == null ? void 0 : r.colors) == null ? void 0 : a[Number(n) - 1]) ?? e;
}, an = (e, t = "default", n) => {
  if (n)
    return xi(n);
  const r = jr.find(({ name: a }) => a === t) ?? $i;
  return r.colors[e % r.colors.length];
}, cf = he(
  function({
    data: t
  }) {
    const [n, r] = Q(0);
    return ne(() => {
      r(Date.now() - t);
    }, [t]), Ns(() => {
      r(Date.now() - t);
    }, 1e3), /* @__PURE__ */ g.jsx(g.Fragment, { children: Ft(n, "timer") });
  }
), lf = "_wrapper_md8oe_27", uf = "_text_md8oe_32", Ta = {
  wrapper: lf,
  text: uf
}, ff = he(function({
  className: t,
  data: n,
  format: r,
  color: a,
  suffix: o
}) {
  const i = J(() => {
    if (n === null) return "n.a.";
    switch (r) {
      case "timer":
        return /* @__PURE__ */ g.jsx(cf, { data: n });
      default:
        return Ft(n, r);
    }
  }, [n, r]), s = J(() => {
    if (n !== null)
      switch (r) {
        case "duration":
          return Ke(n);
        case "count":
          return It(n);
        default:
          return;
      }
  }, [n, r]), l = !(n !== null && s !== i) || ["number", "percentage", "timer"].includes(r);
  return /* @__PURE__ */ g.jsx(
    Dt,
    {
      content: s,
      disabled: l,
      wrap: "div",
      wrapProps: { className: Ta.wrapper },
      children: /* @__PURE__ */ g.jsxs(
        W.Heading,
        {
          variant: "heading-1",
          color: a ?? (n === null ? ut.color.tertiary : void 0),
          className: Oe(Ta.text, t),
          as: "span",
          children: [
            i,
            o
          ]
        }
      )
    }
  );
}), df = "_colorIndicator_luubh_1", pf = {
  colorIndicator: df
}, _i = he(function({
  instrument: t,
  theme: n = "light"
}) {
  const { data: r, format: a, title: o, description: i, color: s } = t, c = s ? xi(s) : void 0, l = n === "dark" ? "white" : void 0;
  return /* @__PURE__ */ g.jsxs(K, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ g.jsxs(K, { alignItems: "center", gap: "100", title: o, children: [
      s && /* @__PURE__ */ g.jsx(
        $r,
        {
          as: "span",
          className: pf.colorIndicator,
          background: c
        }
      ),
      /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "4", color: l, subdued: !0, children: o })
    ] }),
    /* @__PURE__ */ g.jsx(ff, { data: r, format: a, color: l }),
    i && /* @__PURE__ */ g.jsx(
      W.Paragraph,
      {
        variant: "4",
        color: n === "dark" ? "white" : void 0,
        subdued: !0,
        children: i
      }
    )
  ] });
});
var vf = typeof Wt == "object" && Wt && Wt.Object === Object && Wt, wi = vf, hf = wi, gf = typeof self == "object" && self && self.Object === Object && self, mf = hf || gf || Function("return this")(), Ee = mf, bf = Ee, yf = bf.Symbol, Lt = yf;
function $f(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = Array(r); ++n < r; )
    a[n] = t(e[n], n, e);
  return a;
}
var Ci = $f, xf = Array.isArray, ye = xf, Ra = Lt, Ei = Object.prototype, _f = Ei.hasOwnProperty, wf = Ei.toString, St = Ra ? Ra.toStringTag : void 0;
function Cf(e) {
  var t = _f.call(e, St), n = e[St];
  try {
    e[St] = void 0;
    var r = !0;
  } catch {
  }
  var a = wf.call(e);
  return r && (t ? e[St] = n : delete e[St]), a;
}
var Ef = Cf, Pf = Object.prototype, Sf = Pf.toString;
function Of(e) {
  return Sf.call(e);
}
var Af = Of, ja = Lt, Tf = Ef, Rf = Af, jf = "[object Null]", If = "[object Undefined]", Ia = ja ? ja.toStringTag : void 0;
function Df(e) {
  return e == null ? e === void 0 ? If : jf : Ia && Ia in Object(e) ? Tf(e) : Rf(e);
}
var Xe = Df;
function Mf(e) {
  return e != null && typeof e == "object";
}
var Ze = Mf, Nf = Xe, Ff = Ze, Lf = "[object Symbol]";
function kf(e) {
  return typeof e == "symbol" || Ff(e) && Nf(e) == Lf;
}
var kt = kf, Da = Lt, Vf = Ci, Bf = ye, Uf = kt, Hf = 1 / 0, Ma = Da ? Da.prototype : void 0, Na = Ma ? Ma.toString : void 0;
function Pi(e) {
  if (typeof e == "string")
    return e;
  if (Bf(e))
    return Vf(e, Pi) + "";
  if (Uf(e))
    return Na ? Na.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Hf ? "-0" : t;
}
var Si = Pi;
function Wf(e, t, n) {
  var r = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), n = n > a ? a : n, n < 0 && (n += a), a = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(a); ++r < a; )
    o[r] = e[r + t];
  return o;
}
var zf = Wf, Gf = zf;
function Kf(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : Gf(e, t, n);
}
var Yf = Kf, qf = "\\ud800-\\udfff", Xf = "\\u0300-\\u036f", Zf = "\\ufe20-\\ufe2f", Jf = "\\u20d0-\\u20ff", Qf = Xf + Zf + Jf, ed = "\\ufe0e\\ufe0f", td = "\\u200d", nd = RegExp("[" + td + qf + Qf + ed + "]");
function rd(e) {
  return nd.test(e);
}
var Ir = rd;
function ad(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Je = ad, od = Xe, id = Ze, sd = "[object RegExp]";
function cd(e) {
  return id(e) && od(e) == sd;
}
var ld = cd;
function ud(e) {
  return function(t) {
    return e(t);
  };
}
var Dr = ud, pn = { exports: {} };
pn.exports;
(function(e, t) {
  var n = wi, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, o = a && a.exports === r, i = o && n.process, s = function() {
    try {
      var c = a && a.require && a.require("util").types;
      return c || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(pn, pn.exports);
var Oi = pn.exports, fd = ld, dd = Dr, Fa = Oi, La = Fa && Fa.isRegExp, pd = La ? dd(La) : fd, vd = pd;
function hd(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Ai = hd, gd = Ai, md = gd("length"), bd = md, Ti = "\\ud800-\\udfff", yd = "\\u0300-\\u036f", $d = "\\ufe20-\\ufe2f", xd = "\\u20d0-\\u20ff", _d = yd + $d + xd, wd = "\\ufe0e\\ufe0f", Cd = "[" + Ti + "]", cr = "[" + _d + "]", lr = "\\ud83c[\\udffb-\\udfff]", Ed = "(?:" + cr + "|" + lr + ")", Ri = "[^" + Ti + "]", ji = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ii = "[\\ud800-\\udbff][\\udc00-\\udfff]", Pd = "\\u200d", Di = Ed + "?", Mi = "[" + wd + "]?", Sd = "(?:" + Pd + "(?:" + [Ri, ji, Ii].join("|") + ")" + Mi + Di + ")*", Od = Mi + Di + Sd, Ad = "(?:" + [Ri + cr + "?", cr, ji, Ii, Cd].join("|") + ")", ka = RegExp(lr + "(?=" + lr + ")|" + Ad + Od, "g");
function Td(e) {
  for (var t = ka.lastIndex = 0; ka.test(e); )
    ++t;
  return t;
}
var Rd = Td, jd = bd, Id = Ir, Dd = Rd;
function Md(e) {
  return Id(e) ? Dd(e) : jd(e);
}
var Nd = Md;
function Fd(e) {
  return e.split("");
}
var Ld = Fd, Ni = "\\ud800-\\udfff", kd = "\\u0300-\\u036f", Vd = "\\ufe20-\\ufe2f", Bd = "\\u20d0-\\u20ff", Ud = kd + Vd + Bd, Hd = "\\ufe0e\\ufe0f", Wd = "[" + Ni + "]", ur = "[" + Ud + "]", fr = "\\ud83c[\\udffb-\\udfff]", zd = "(?:" + ur + "|" + fr + ")", Fi = "[^" + Ni + "]", Li = "(?:\\ud83c[\\udde6-\\uddff]){2}", ki = "[\\ud800-\\udbff][\\udc00-\\udfff]", Gd = "\\u200d", Vi = zd + "?", Bi = "[" + Hd + "]?", Kd = "(?:" + Gd + "(?:" + [Fi, Li, ki].join("|") + ")" + Bi + Vi + ")*", Yd = Bi + Vi + Kd, qd = "(?:" + [Fi + ur + "?", ur, Li, ki, Wd].join("|") + ")", Xd = RegExp(fr + "(?=" + fr + ")|" + qd + Yd, "g");
function Zd(e) {
  return e.match(Xd) || [];
}
var Jd = Zd, Qd = Ld, ep = Ir, tp = Jd;
function np(e) {
  return ep(e) ? tp(e) : Qd(e);
}
var rp = np, ap = /\s/;
function op(e) {
  for (var t = e.length; t-- && ap.test(e.charAt(t)); )
    ;
  return t;
}
var ip = op, sp = ip, cp = /^\s+/;
function lp(e) {
  return e && e.slice(0, sp(e) + 1).replace(cp, "");
}
var up = lp, fp = up, Va = Je, dp = kt, Ba = NaN, pp = /^[-+]0x[0-9a-f]+$/i, vp = /^0b[01]+$/i, hp = /^0o[0-7]+$/i, gp = parseInt;
function mp(e) {
  if (typeof e == "number")
    return e;
  if (dp(e))
    return Ba;
  if (Va(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Va(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = fp(e);
  var n = vp.test(e);
  return n || hp.test(e) ? gp(e.slice(2), n ? 2 : 8) : pp.test(e) ? Ba : +e;
}
var Ui = mp, bp = Ui, Ua = 1 / 0, yp = 17976931348623157e292;
function $p(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = bp(e), e === Ua || e === -Ua) {
    var t = e < 0 ? -1 : 1;
    return t * yp;
  }
  return e === e ? e : 0;
}
var xp = $p, _p = xp;
function wp(e) {
  var t = _p(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var Cp = wp, Ep = Si;
function Pp(e) {
  return e == null ? "" : Ep(e);
}
var Hi = Pp, Ha = Si, Sp = Yf, Op = Ir, Ap = Je, Tp = vd, Rp = Nd, jp = rp, Ip = Cp, Wa = Hi, Dp = 30, Mp = "...", Np = /\w*$/;
function Fp(e, t) {
  var n = Dp, r = Mp;
  if (Ap(t)) {
    var a = "separator" in t ? t.separator : a;
    n = "length" in t ? Ip(t.length) : n, r = "omission" in t ? Ha(t.omission) : r;
  }
  e = Wa(e);
  var o = e.length;
  if (Op(e)) {
    var i = jp(e);
    o = i.length;
  }
  if (n >= o)
    return e;
  var s = n - Rp(r);
  if (s < 1)
    return r;
  var c = i ? Sp(i, 0, s).join("") : e.slice(0, s);
  if (a === void 0)
    return c + r;
  if (i && (s += c.length - s), Tp(a)) {
    if (e.slice(s).search(a)) {
      var l, v = c;
      for (a.global || (a = RegExp(a.source, Wa(Np.exec(a)) + "g")), a.lastIndex = 0; l = a.exec(v); )
        var u = l.index;
      c = c.slice(0, u === void 0 ? s : u);
    }
  } else if (e.indexOf(Ha(a), s) != s) {
    var p = c.lastIndexOf(a);
    p > -1 && (c = c.slice(0, p));
  }
  return c + r;
}
var Lp = Fp;
const kp = /* @__PURE__ */ je(Lp), Wi = (e, t = "D", {
  long: n = !1,
  timezone: r = Le.tz.guess()
} = {}) => {
  const a = Le.tz(e, r), o = Le.locale() === "en", i = (s) => n ? s.format("ddd, ll") : s.format(o ? "MMM DD" : "DD MMM");
  switch (t) {
    case "H":
      return a.format("LT");
    case "W":
      return n ? `${i(a)} - ${i(
        a.endOf("week")
      )} (W${a.format("W")})` : i(a);
    case "M":
      return a.format(n ? "MMM YYYY" : "MMM");
    case "D":
    default:
      return i(a);
  }
}, zi = (e, t = {}) => t != null && t.length ? kp(e, t) : e, Vp = he(function({
  instrument: t,
  granularity: n,
  timezone: r,
  tooltipProps: a
}) {
  const { active: o, payload: i, label: s } = a, { categories: c, series: l } = t.data, v = c.find(($) => $.label === s), u = (v == null ? void 0 : v.metrics) ?? [], p = 6 * 4, d = Math.max(0, ((i == null ? void 0 : i.length) ?? 0) - p), m = J(
    () => i == null ? void 0 : i.slice(
      0,
      // When there are more series than the limit, subtract one to make room for the overflow indicator.
      d > 0 ? p - 1 : p
    ).map(($, y) => {
      var _;
      return {
        type: "metric",
        title: $.name ?? "",
        color: $.color,
        format: ((_ = l[y].options) == null ? void 0 : _.format) ?? "number",
        data: $.value ?? 0
      };
    }),
    [i, l, p, d]
  ), h = q(
    ($) => $ == null ? void 0 : $.map((y) => /* @__PURE__ */ g.jsx(
      _i,
      {
        instrument: y,
        theme: "dark"
      },
      y.title
    )),
    []
  ), b = J(
    () => Le(s, Le.ISO_8601).isValid() ? Wi(s, n, { timezone: r, long: !0 }) : zi(s),
    [n, s, r]
  );
  return !o || !i ? null : /* @__PURE__ */ g.jsxs(
    K,
    {
      padding: "250",
      borderWidth: "1px",
      background: k.neutral[900],
      boxShadow: Is["box-shadow"][300],
      borderColor: k.neutral[900],
      borderRadius: xr.border[200],
      flexDirection: "column",
      gap: "300",
      children: [
        /* @__PURE__ */ g.jsxs(K, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ g.jsx(W.Paragraph, { as: "div", variant: "1", color: "white", children: b }),
          (v == null ? void 0 : v.description) && /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "4", color: "white", children: v.description })
        ] }),
        u.length > 0 && /* @__PURE__ */ g.jsx(sr, { bounded: !0, children: h(u) }),
        /* @__PURE__ */ g.jsxs(sr, { bounded: !0, children: [
          h(m),
          d > 0 && /* @__PURE__ */ g.jsx(K, { flex: "1", alignItems: "center", children: /* @__PURE__ */ g.jsxs(W.Heading, { variant: "heading-2", color: "white", children: [
            "+ ",
            d + 1,
            " more"
          ] }) })
        ] })
      ]
    }
  );
}), Bp = {
  fontFamily: ut.family.default,
  fontSize: ut.size[200],
  fill: ut.color.tertiary
}, Up = {
  bar: "chart-bar",
  line: "activity"
}, dt = {
  tickCount: 5,
  tickProps: Bp,
  visualizationIcons: Up
}, Hp = ["bar", "line"], Wp = he(
  function({
    visualization: t,
    onChangeVisualization: n
  }) {
    return /* @__PURE__ */ g.jsx(Ao, { variant: "secondary", children: Hp.map((r) => /* @__PURE__ */ g.jsx(
      yr,
      {
        icon: dt.visualizationIcons[r],
        onClick: () => {
          n(r);
        },
        active: t === r
      },
      r
    )) });
  }
), zp = ({
  instrument: e,
  granularity: t,
  timezone: n,
  syncOptions: r
}) => {
  const { data: a, layout: o } = e, i = o === "horizontal", s = o === "vertical", c = 192, l = J(() => {
    if (s) return 0;
    const m = a.categories.length % 2 === 0;
    switch (t) {
      case "H":
        return "preserveStart";
      case "D":
      case "W":
        return m ? "preserveEnd" : "preserveStart";
      default:
        return "preserveStartEnd";
    }
  }, [a.categories.length, t, s]), v = {
    dataKey: "name",
    width: s ? c : 0,
    tickLine: {
      stroke: k.neutral[200]
    },
    axisLine: {
      stroke: k.neutral[200]
    },
    tickSize: 6,
    tickMargin: 8,
    interval: l,
    tick: dt.tickProps,
    tickFormatter: (m) => Le(m, Le.ISO_8601).isValid() ? Wi(m, t, { timezone: n }) : zi(m, { length: c / 10 })
  }, u = {
    domain: [0, "auto"],
    allowDecimals: !1,
    tickLine: !1,
    axisLine: !1,
    tick: dt.tickProps,
    ticks: r == null ? void 0 : r.ticks,
    tickCount: dt.tickCount,
    tickFormatter: (m) => {
      var h;
      return Ft(m, ((h = a.series[0].options) == null ? void 0 : h.format) ?? "number");
    }
  }, p = i ? { type: "category", ...v } : { type: "number", ...u }, d = i ? { type: "number", ...u } : { type: "category", ...v };
  return { xAxisProps: p, yAxisProps: d };
};
var Gp = Ee, Kp = function() {
  return Gp.Date.now();
}, Yp = Kp, qp = Je, zn = Yp, za = Ui, Xp = "Expected a function", Zp = Math.max, Jp = Math.min;
function Qp(e, t, n) {
  var r, a, o, i, s, c, l = 0, v = !1, u = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(Xp);
  t = za(t) || 0, qp(n) && (v = !!n.leading, u = "maxWait" in n, o = u ? Zp(za(n.maxWait) || 0, t) : o, p = "trailing" in n ? !!n.trailing : p);
  function d(E) {
    var O = r, S = a;
    return r = a = void 0, l = E, i = e.apply(S, O), i;
  }
  function m(E) {
    return l = E, s = setTimeout($, t), v ? d(E) : i;
  }
  function h(E) {
    var O = E - c, S = E - l, A = t - O;
    return u ? Jp(A, o - S) : A;
  }
  function b(E) {
    var O = E - c, S = E - l;
    return c === void 0 || O >= t || O < 0 || u && S >= o;
  }
  function $() {
    var E = zn();
    if (b(E))
      return y(E);
    s = setTimeout($, h(E));
  }
  function y(E) {
    return s = void 0, p && r ? d(E) : (r = a = void 0, i);
  }
  function x() {
    s !== void 0 && clearTimeout(s), l = 0, r = c = a = s = void 0;
  }
  function _() {
    return s === void 0 ? i : y(zn());
  }
  function w() {
    var E = zn(), O = b(E);
    if (r = arguments, a = this, c = E, O) {
      if (s === void 0)
        return m(c);
      if (u)
        return clearTimeout(s), s = setTimeout($, t), d(c);
    }
    return s === void 0 && (s = setTimeout($, t)), i;
  }
  return w.cancel = x, w.flush = _, w;
}
var ev = Qp;
const tv = /* @__PURE__ */ je(ev), nv = "_legendItem_17mul_27", rv = "_legendItemInactive_17mul_34", av = "_legendIcon_17mul_38", ov = "_legendIconBar_17mul_45", iv = "_legendIconLine_17mul_48", Ot = {
  legendItem: nv,
  legendItemInactive: rv,
  legendIcon: av,
  legendIconBar: ov,
  legendIconLine: iv
}, sv = he(function({
  instrument: t,
  legend: n,
  visualization: r,
  onToggleLegendItem: a,
  onMouseEnterLegendItem: o,
  onMouseLeaveLegendItem: i,
  hoveredLegend: s
}) {
  const { series: c, options: l } = t.data, { layout: v } = (l == null ? void 0 : l.legend) ?? {
    layout: "horizontal"
  }, u = v === "horizontal";
  return /* @__PURE__ */ g.jsx(
    K,
    {
      padding: u ? "0" : "0 0 0 400",
      flexDirection: u ? "row" : "column",
      gap: u ? "400" : "200",
      justifyContent: "center",
      children: c.map(({ label: p, options: d }, m) => {
        const h = an(
          m,
          void 0,
          d == null ? void 0 : d.color
        ), b = Oe(Ot.legendItem, {
          [Ot.legendItemInactive]: s && s !== p
        }), $ = Oe(Ot.legendIcon, {
          [Ot.legendIconBar]: r === "bar",
          [Ot.legendIconLine]: r === "line"
        });
        return /* @__PURE__ */ g.jsxs(
          K,
          {
            gap: "200",
            flexDirection: "row",
            alignItems: "center",
            className: b,
            onClick: () => a(p),
            onMouseEnter: () => o == null ? void 0 : o(p),
            onMouseLeave: () => i == null ? void 0 : i(p),
            children: [
              /* @__PURE__ */ g.jsx(
                "span",
                {
                  className: $,
                  style: {
                    borderColor: h,
                    backgroundColor: n.includes(p) ? h : "transparent"
                  }
                }
              ),
              /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "4", subdued: !0, children: p })
            ]
          },
          p
        );
      })
    }
  );
}), cv = ({
  instrument: e,
  visualization: t
}) => {
  var b, $;
  const {
    data: { series: n, options: r }
  } = e, a = ((b = r == null ? void 0 : r.legend) == null ? void 0 : b.layout) === "horizontal", [o, i] = Fs(
    n.filter(({ options: y }) => (y == null ? void 0 : y.visible) ?? !0).map(({ label: y }) => y)
  ), [s, c] = Q(null);
  Mt(() => {
    l();
  }, [n.length]);
  const l = q(() => {
    i.set(n.map(({ label: y }) => y));
  }, [n, i]), v = q(
    (y) => {
      o.includes(y) && c(y);
    },
    [o]
  ), u = J(
    () => tv(v, 300),
    [v]
  ), p = q(() => {
    u.cancel(), c(null);
  }, [u]), d = q(
    (y) => {
      o.length === n.length ? i.filter((x) => x === y) : o.length === 1 && o.includes(y) ? l() : o.includes(y) ? i.removeAt(o.indexOf(y)) : i.push(y);
    },
    [n.length, l, o, i]
  ), m = J(
    () => n.length < 10 ? {
      onMouseEnterLegendItem: u,
      onMouseLeaveLegendItem: p,
      hoveredLegend: s
    } : {},
    [
      u,
      p,
      s,
      n.length
    ]
  ), h = J(
    () => {
      var y;
      return {
        layout: (y = r == null ? void 0 : r.legend) == null ? void 0 : y.layout,
        align: a ? "center" : "right",
        verticalAlign: a ? "bottom" : "middle",
        wrapperStyle: {
          overflow: "auto",
          ...a ? {
            bottom: 0
          } : {
            right: 0,
            width: 208,
            maxHeight: "100%"
          }
        },
        // Using the render function form instead of directly passing an element prevents the
        // `ChartInstrumentLegend` component from re-rendering unnecessarily due to Recharts props
        // changing, because Recharts automatically passes props to the `content` element.
        content: () => /* @__PURE__ */ g.jsx(
          sv,
          {
            visualization: t,
            instrument: e,
            legend: o,
            onToggleLegendItem: d,
            ...m
          }
        )
      };
    },
    [
      d,
      e,
      a,
      o,
      m,
      ($ = r == null ? void 0 : r.legend) == null ? void 0 : $.layout,
      t
    ]
  );
  return {
    legend: o,
    legendProps: h,
    hoveredLegend: s
  };
};
function lv(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var uv = lv;
const fv = /* @__PURE__ */ je(uv);
var dv = ye, pv = kt, vv = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, hv = /^\w*$/;
function gv(e, t) {
  if (dv(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || pv(e) ? !0 : hv.test(e) || !vv.test(e) || t != null && e in Object(t);
}
var Mr = gv, mv = Xe, bv = Je, yv = "[object AsyncFunction]", $v = "[object Function]", xv = "[object GeneratorFunction]", _v = "[object Proxy]";
function wv(e) {
  if (!bv(e))
    return !1;
  var t = mv(e);
  return t == $v || t == xv || t == yv || t == _v;
}
var Gi = wv, Cv = Ee, Ev = Cv["__core-js_shared__"], Pv = Ev, Gn = Pv, Ga = function() {
  var e = /[^.]+$/.exec(Gn && Gn.keys && Gn.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Sv(e) {
  return !!Ga && Ga in e;
}
var Ov = Sv, Av = Function.prototype, Tv = Av.toString;
function Rv(e) {
  if (e != null) {
    try {
      return Tv.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Ki = Rv, jv = Gi, Iv = Ov, Dv = Je, Mv = Ki, Nv = /[\\^$.*+?()[\]{}|]/g, Fv = /^\[object .+?Constructor\]$/, Lv = Function.prototype, kv = Object.prototype, Vv = Lv.toString, Bv = kv.hasOwnProperty, Uv = RegExp(
  "^" + Vv.call(Bv).replace(Nv, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Hv(e) {
  if (!Dv(e) || Iv(e))
    return !1;
  var t = jv(e) ? Uv : Fv;
  return t.test(Mv(e));
}
var Wv = Hv;
function zv(e, t) {
  return e == null ? void 0 : e[t];
}
var Gv = zv, Kv = Wv, Yv = Gv;
function qv(e, t) {
  var n = Yv(e, t);
  return Kv(n) ? n : void 0;
}
var Qe = qv, Xv = Qe, Zv = Xv(Object, "create"), $n = Zv, Ka = $n;
function Jv() {
  this.__data__ = Ka ? Ka(null) : {}, this.size = 0;
}
var Qv = Jv;
function eh(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var th = eh, nh = $n, rh = "__lodash_hash_undefined__", ah = Object.prototype, oh = ah.hasOwnProperty;
function ih(e) {
  var t = this.__data__;
  if (nh) {
    var n = t[e];
    return n === rh ? void 0 : n;
  }
  return oh.call(t, e) ? t[e] : void 0;
}
var sh = ih, ch = $n, lh = Object.prototype, uh = lh.hasOwnProperty;
function fh(e) {
  var t = this.__data__;
  return ch ? t[e] !== void 0 : uh.call(t, e);
}
var dh = fh, ph = $n, vh = "__lodash_hash_undefined__";
function hh(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ph && t === void 0 ? vh : t, this;
}
var gh = hh, mh = Qv, bh = th, yh = sh, $h = dh, xh = gh;
function yt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
yt.prototype.clear = mh;
yt.prototype.delete = bh;
yt.prototype.get = yh;
yt.prototype.has = $h;
yt.prototype.set = xh;
var _h = yt;
function wh() {
  this.__data__ = [], this.size = 0;
}
var Ch = wh;
function Eh(e, t) {
  return e === t || e !== e && t !== t;
}
var Nr = Eh, Ph = Nr;
function Sh(e, t) {
  for (var n = e.length; n--; )
    if (Ph(e[n][0], t))
      return n;
  return -1;
}
var xn = Sh, Oh = xn, Ah = Array.prototype, Th = Ah.splice;
function Rh(e) {
  var t = this.__data__, n = Oh(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Th.call(t, n, 1), --this.size, !0;
}
var jh = Rh, Ih = xn;
function Dh(e) {
  var t = this.__data__, n = Ih(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Mh = Dh, Nh = xn;
function Fh(e) {
  return Nh(this.__data__, e) > -1;
}
var Lh = Fh, kh = xn;
function Vh(e, t) {
  var n = this.__data__, r = kh(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var Bh = Vh, Uh = Ch, Hh = jh, Wh = Mh, zh = Lh, Gh = Bh;
function $t(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
$t.prototype.clear = Uh;
$t.prototype.delete = Hh;
$t.prototype.get = Wh;
$t.prototype.has = zh;
$t.prototype.set = Gh;
var _n = $t, Kh = Qe, Yh = Ee, qh = Kh(Yh, "Map"), Fr = qh, Ya = _h, Xh = _n, Zh = Fr;
function Jh() {
  this.size = 0, this.__data__ = {
    hash: new Ya(),
    map: new (Zh || Xh)(),
    string: new Ya()
  };
}
var Qh = Jh;
function eg(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var tg = eg, ng = tg;
function rg(e, t) {
  var n = e.__data__;
  return ng(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var wn = rg, ag = wn;
function og(e) {
  var t = ag(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var ig = og, sg = wn;
function cg(e) {
  return sg(this, e).get(e);
}
var lg = cg, ug = wn;
function fg(e) {
  return ug(this, e).has(e);
}
var dg = fg, pg = wn;
function vg(e, t) {
  var n = pg(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var hg = vg, gg = Qh, mg = ig, bg = lg, yg = dg, $g = hg;
function xt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
xt.prototype.clear = gg;
xt.prototype.delete = mg;
xt.prototype.get = bg;
xt.prototype.has = yg;
xt.prototype.set = $g;
var Lr = xt, Yi = Lr, xg = "Expected a function";
function kr(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(xg);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(a))
      return o.get(a);
    var i = e.apply(this, r);
    return n.cache = o.set(a, i) || o, i;
  };
  return n.cache = new (kr.Cache || Yi)(), n;
}
kr.Cache = Yi;
var _g = kr, wg = _g, Cg = 500;
function Eg(e) {
  var t = wg(e, function(r) {
    return n.size === Cg && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Pg = Eg, Sg = Pg, Og = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ag = /\\(\\)?/g, Tg = Sg(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Og, function(n, r, a, o) {
    t.push(a ? o.replace(Ag, "$1") : r || n);
  }), t;
}), Rg = Tg, jg = ye, Ig = Mr, Dg = Rg, Mg = Hi;
function Ng(e, t) {
  return jg(e) ? e : Ig(e, t) ? [e] : Dg(Mg(e));
}
var Cn = Ng, Fg = kt, Lg = 1 / 0;
function kg(e) {
  if (typeof e == "string" || Fg(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Lg ? "-0" : t;
}
var Vt = kg, Vg = Cn, Bg = Vt;
function Ug(e, t) {
  t = Vg(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[Bg(t[n++])];
  return n && n == r ? e : void 0;
}
var En = Ug, Hg = Qe, Wg = function() {
  try {
    var e = Hg(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), qi = Wg, qa = qi;
function zg(e, t, n) {
  t == "__proto__" && qa ? qa(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Gg = zg, Kg = Gg, Yg = Nr, qg = Object.prototype, Xg = qg.hasOwnProperty;
function Zg(e, t, n) {
  var r = e[t];
  (!(Xg.call(e, t) && Yg(r, n)) || n === void 0 && !(t in e)) && Kg(e, t, n);
}
var Jg = Zg, Qg = 9007199254740991, em = /^(?:0|[1-9]\d*)$/;
function tm(e, t) {
  var n = typeof e;
  return t = t ?? Qg, !!t && (n == "number" || n != "symbol" && em.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Vr = tm, nm = Jg, rm = Cn, am = Vr, Xa = Je, om = Vt;
function im(e, t, n, r) {
  if (!Xa(e))
    return e;
  t = rm(t, e);
  for (var a = -1, o = t.length, i = o - 1, s = e; s != null && ++a < o; ) {
    var c = om(t[a]), l = n;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return e;
    if (a != i) {
      var v = s[c];
      l = r ? r(v, c, s) : void 0, l === void 0 && (l = Xa(v) ? v : am(t[a + 1]) ? [] : {});
    }
    nm(s, c, l), s = s[c];
  }
  return e;
}
var sm = im, cm = En, lm = sm, um = Cn;
function fm(e, t, n) {
  for (var r = -1, a = t.length, o = {}; ++r < a; ) {
    var i = t[r], s = cm(e, i);
    n(s, i) && lm(o, um(i, e), s);
  }
  return o;
}
var dm = fm;
function pm(e, t) {
  return e != null && t in Object(e);
}
var vm = pm, hm = Xe, gm = Ze, mm = "[object Arguments]";
function bm(e) {
  return gm(e) && hm(e) == mm;
}
var ym = bm, Za = ym, $m = Ze, Xi = Object.prototype, xm = Xi.hasOwnProperty, _m = Xi.propertyIsEnumerable, wm = Za(/* @__PURE__ */ function() {
  return arguments;
}()) ? Za : function(e) {
  return $m(e) && xm.call(e, "callee") && !_m.call(e, "callee");
}, Br = wm, Cm = 9007199254740991;
function Em(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Cm;
}
var Ur = Em, Pm = Cn, Sm = Br, Om = ye, Am = Vr, Tm = Ur, Rm = Vt;
function jm(e, t, n) {
  t = Pm(t, e);
  for (var r = -1, a = t.length, o = !1; ++r < a; ) {
    var i = Rm(t[r]);
    if (!(o = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return o || ++r != a ? o : (a = e == null ? 0 : e.length, !!a && Tm(a) && Am(i, a) && (Om(e) || Sm(e)));
}
var Im = jm, Dm = vm, Mm = Im;
function Nm(e, t) {
  return e != null && Mm(e, t, Dm);
}
var Zi = Nm, Fm = dm, Lm = Zi;
function km(e, t) {
  return Fm(e, t, function(n, r) {
    return Lm(e, r);
  });
}
var Vm = km;
function Bm(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r; )
    e[a + n] = t[n];
  return e;
}
var Ji = Bm, Ja = Lt, Um = Br, Hm = ye, Qa = Ja ? Ja.isConcatSpreadable : void 0;
function Wm(e) {
  return Hm(e) || Um(e) || !!(Qa && e && e[Qa]);
}
var zm = Wm, Gm = Ji, Km = zm;
function Qi(e, t, n, r, a) {
  var o = -1, i = e.length;
  for (n || (n = Km), a || (a = []); ++o < i; ) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? Qi(s, t - 1, n, r, a) : Gm(a, s) : r || (a[a.length] = s);
  }
  return a;
}
var Ym = Qi, qm = Ym;
function Xm(e) {
  var t = e == null ? 0 : e.length;
  return t ? qm(e, 1) : [];
}
var Zm = Xm;
function Jm(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Qm = Jm, eb = Qm, eo = Math.max;
function tb(e, t, n) {
  return t = eo(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, a = -1, o = eo(r.length - t, 0), i = Array(o); ++a < o; )
      i[a] = r[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = r[a];
    return s[t] = n(i), eb(e, this, s);
  };
}
var nb = tb;
function rb(e) {
  return function() {
    return e;
  };
}
var ab = rb;
function ob(e) {
  return e;
}
var Pn = ob, ib = ab, to = qi, sb = Pn, cb = to ? function(e, t) {
  return to(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ib(t),
    writable: !0
  });
} : sb, lb = cb, ub = 800, fb = 16, db = Date.now;
function pb(e) {
  var t = 0, n = 0;
  return function() {
    var r = db(), a = fb - (r - n);
    if (n = r, a > 0) {
      if (++t >= ub)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var vb = pb, hb = lb, gb = vb, mb = gb(hb), bb = mb, yb = Zm, $b = nb, xb = bb;
function _b(e) {
  return xb($b(e, void 0, yb), e + "");
}
var wb = _b, Cb = Vm, Eb = wb, Pb = Eb(function(e, t) {
  return e == null ? {} : Cb(e, t);
}), Sb = Pb;
const Ob = /* @__PURE__ */ je(Sb);
function Ab(e, t) {
  for (var n, r = -1, a = e.length; ++r < a; ) {
    var o = t(e[r]);
    o !== void 0 && (n = n === void 0 ? o : n + o);
  }
  return n;
}
var Tb = Ab, Rb = Tb, jb = Pn;
function Ib(e) {
  return e && e.length ? Rb(e, jb) : 0;
}
var Db = Ib;
const Mb = /* @__PURE__ */ je(Db), Nb = ({
  instrument: e,
  legend: t,
  hoveredLegend: n,
  hoveredCategory: r
}) => {
  const { data: a, layout: o } = e, i = q(() => {
    const { series: l } = a;
    return l.map(({ label: u, options: p }, d) => {
      var $;
      const m = an(
        d,
        ($ = a.options) == null ? void 0 : $.theme,
        p == null ? void 0 : p.color
      );
      return {
        key: u,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: u,
        stroke: m,
        strokeWidth: 2,
        strokeOpacity: n === null || n === u ? 1 : 0.4,
        connectNulls: !0,
        hide: !t.includes(u),
        animationEasing: "linear"
      };
    });
  }, [a, n, t]), s = q(() => {
    const { categories: l, series: v } = a, u = v.filter(({ label: h }) => t.includes(h)), p = o === "vertical", d = p ? [0, 2, 2, 0] : [2, 2, 0, 0];
    return v.map(
      ({ label: h, options: b, data: $ }, y) => {
        var A, U;
        const x = an(
          y,
          (A = a.options) == null ? void 0 : A.theme,
          b == null ? void 0 : b.color
        ), _ = b == null ? void 0 : b.stack, w = _ ? ((U = fv(u)) == null ? void 0 : U.label) === h : !0, E = u.length <= 10 && (_ ? w : !0), O = /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
          E && /* @__PURE__ */ g.jsx(
            ks,
            {
              position: p ? "right" : "top",
              valueAccessor: ({ payload: j }) => (
                // In the case of stacked series, the total sum of all
                // visible series values for the current category is
                // displayed. For individual series, their own value is
                // displayed by using their `label` from the Recharts data.
                _ ? Mb(Object.values(Ob(j, t))) : Number(j[h] ?? 0)
              ),
              formatter: (j) => j ? Ft(j, (b == null ? void 0 : b.format) ?? "number") : "",
              ...dt.tickProps,
              offset: 8,
              fontSize: ut.size[100]
            }
          ),
          $.map((j, z) => {
            var M, ae, F;
            const D = v.length > 1 ? x : an(
              z,
              (M = a.options) == null ? void 0 : M.theme,
              // If there is only one series, the category color is used if specified, otherwise
              // the colors are determined by the category index, resulting in different colors
              // being used for each category and repeating as necessary.
              ((F = (ae = l[z]) == null ? void 0 : ae.options) == null ? void 0 : F.color) ?? (b == null ? void 0 : b.color)
            ), I = r === null || r === z, Y = n === null || n === h;
            return /* @__PURE__ */ g.jsx(
              Vs,
              {
                fill: D,
                fillOpacity: I && Y ? 1 : 0.4
              },
              `${h}-${z}`
            );
          })
        ] });
        return {
          key: h,
          dataKey: h,
          stackId: _,
          fill: x,
          radius: w ? d : 0,
          maxBarSize: 80,
          hide: !t.includes(h),
          animationEasing: "linear",
          children: O
        };
      }
    );
  }, [a, r, n, o, t]);
  return { getSeriesProps: q(
    (l) => l === "line" ? i() : l === "bar" ? s() : [],
    [s, i]
  ) };
}, Fb = (e, t) => e.categories.map((n, r) => {
  const a = e.series.reduce(
    (i, { label: s, data: c }) => {
      const { value: l } = Hr(c[r]);
      return (t.omitZero ? !l : l === null) ? i : { ...i, [s]: l };
    },
    {}
  );
  return {
    name: n.label,
    ...a
  };
}), Hr = (e) => e === null || typeof e == "number" ? { value: e } : {
  value: (e == null ? void 0 : e.value) ?? null,
  metrics: e == null ? void 0 : e.metrics
}, X_ = he(function({
  instrument: t,
  panel: n,
  timezone: r,
  syncOptions: a,
  onChangeGranularity: o,
  onChangeVisualization: i
}) {
  var Y, M, ae;
  const [s, c] = Q(
    ((Y = n.controls) == null ? void 0 : Y.settings.visualization) ?? t.visualization
  ), [l, v] = Q(null), { data: u, layout: p, title: d } = t, m = p === "horizontal", h = p === "vertical", b = J(
    () => Fb(u, { omitZero: s === "bar" }),
    [u, s]
  ), $ = J(
    () => {
      var F, X;
      return (X = (F = u.granularities) == null ? void 0 : F.find(({ selected: ie }) => ie)) == null ? void 0 : X.value;
    },
    [u.granularities]
  ), { xAxisProps: y, yAxisProps: x } = zp({
    instrument: t,
    granularity: $,
    timezone: r,
    syncOptions: a
  }), { legend: _, legendProps: w, hoveredLegend: E } = cv({
    instrument: t,
    visualization: s
  }), { getSeriesProps: O } = Nb({
    instrument: t,
    legend: _,
    hoveredLegend: E,
    hoveredCategory: l
  });
  Mt(() => {
    var F;
    c(
      ((F = n.controls) == null ? void 0 : F.settings.visualization) ?? t.visualization
    );
  }, [(M = n.controls) == null ? void 0 : M.settings.visualization, t.visualization]);
  const S = q(
    (F) => {
      c(F), i == null || i(F);
    },
    [i]
  ), A = (F) => {
    if (!(F != null && F.isTooltipActive)) {
      v(null);
      return;
    }
    const X = F.activeTooltipIndex;
    if (typeof X != "number") return;
    const ie = Object.values(b[X] ?? {}).length > 1;
    v(ie ? X : null);
  }, U = () => {
    v(null);
  }, j = () => s === "line" ? O(s).map((X, ie) => /* @__PURE__ */ g.jsx(Zs, { ...X }, ie)) : s === "bar" ? O(s).map((X, ie) => /* @__PURE__ */ g.jsx(Js, { ...X }, ie)) : null, z = () => {
    var He, De, et, Pe, le, Se;
    const F = (De = (He = u.options) == null ? void 0 : He.legend) == null ? void 0 : De.layout, X = parseInt(xr.spacer[300]), ie = {
      layout: p,
      syncId: a != null && a.tooltip ? n.id : void 0,
      data: b,
      margin: {
        top: m ? X : 0,
        right: h || F === "vertical" ? X : 0,
        bottom: F === "horizontal" ? X / 2 : 0,
        left: 0
      }
    }, $e = /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
      /* @__PURE__ */ g.jsx(Us, { ...y }),
      /* @__PURE__ */ g.jsx(Hs, { ...x }),
      ((et = u.options) == null ? void 0 : et.cartesian) && /* @__PURE__ */ g.jsx(
        Ws,
        {
          vertical: h,
          horizontal: m,
          stroke: k.neutral[200]
        }
      ),
      (Pe = u.references) == null ? void 0 : Pe.map(({ value: ge, label: xe }, Me) => /* @__PURE__ */ g.jsx(
        zs,
        {
          ...m ? { y: ge } : { x: ge },
          stroke: k.neutral[500],
          strokeDasharray: "5 5",
          isFront: !0,
          children: /* @__PURE__ */ g.jsx(
            Gs,
            {
              value: xe,
              offset: 8,
              fontSize: ut.size[200],
              position: m ? "insideBottomLeft" : "insideTopLeft"
            }
          )
        },
        Me
      )),
      ((le = u.options) == null ? void 0 : le.legend) && /* @__PURE__ */ g.jsx(Ks, { ...w }),
      ((Se = u.options) == null ? void 0 : Se.tooltip) && /* @__PURE__ */ g.jsx(
        Ys,
        {
          content: (ge) => /* @__PURE__ */ g.jsx(
            Vp,
            {
              instrument: t,
              granularity: $,
              timezone: r,
              tooltipProps: ge
            }
          ),
          cursor: { fill: "transparent" }
        }
      ),
      j()
    ] });
    switch (s) {
      case "bar":
        return /* @__PURE__ */ g.jsx(
          Xs,
          {
            ...ie,
            barGap: "1",
            onMouseMove: A,
            onMouseLeave: U,
            children: $e
          }
        );
      case "line":
        return /* @__PURE__ */ g.jsx(qs, { ...ie, children: $e });
    }
  };
  if (!u.categories.length || !u.series.length)
    return /* @__PURE__ */ g.jsx(
      K,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        children: /* @__PURE__ */ g.jsx(
          Ro,
          {
            title: "No data available",
            description: "There is no data available for the selected period and filters.",
            icon: dt.visualizationIcons[s]
          }
        )
      }
    );
  const D = [
    u.granularities && u.granularities.length > 1 ? /* @__PURE__ */ g.jsx(
      Zu,
      {
        granularities: u.granularities,
        onChangeGranularity: o
      }
    ) : null,
    (ae = u.options) != null && ae.visualizations ? /* @__PURE__ */ g.jsx(
      Wp,
      {
        visualization: s,
        onChangeVisualization: S
      }
    ) : null
  ], I = D.some(Boolean);
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    d && /* @__PURE__ */ g.jsx("div", { children: /* @__PURE__ */ g.jsx(W.Heading, { variant: "heading-4", children: d }) }),
    I && /* @__PURE__ */ g.jsx(K, { alignSelf: "flex-end", gap: "300", children: D.map((F, X) => /* @__PURE__ */ g.jsx(Oo, { children: F }, X)) }),
    /* @__PURE__ */ g.jsx(
      Bs,
      {
        className: Xu.container,
        width: "100%",
        height: "100%",
        debounce: 100,
        children: z()
      }
    )
  ] });
});
var Lb = _n;
function kb() {
  this.__data__ = new Lb(), this.size = 0;
}
var Vb = kb;
function Bb(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var Ub = Bb;
function Hb(e) {
  return this.__data__.get(e);
}
var Wb = Hb;
function zb(e) {
  return this.__data__.has(e);
}
var Gb = zb, Kb = _n, Yb = Fr, qb = Lr, Xb = 200;
function Zb(e, t) {
  var n = this.__data__;
  if (n instanceof Kb) {
    var r = n.__data__;
    if (!Yb || r.length < Xb - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new qb(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var Jb = Zb, Qb = _n, ey = Vb, ty = Ub, ny = Wb, ry = Gb, ay = Jb;
function _t(e) {
  var t = this.__data__ = new Qb(e);
  this.size = t.size;
}
_t.prototype.clear = ey;
_t.prototype.delete = ty;
_t.prototype.get = ny;
_t.prototype.has = ry;
_t.prototype.set = ay;
var es = _t, oy = "__lodash_hash_undefined__";
function iy(e) {
  return this.__data__.set(e, oy), this;
}
var sy = iy;
function cy(e) {
  return this.__data__.has(e);
}
var ly = cy, uy = Lr, fy = sy, dy = ly;
function vn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new uy(); ++t < n; )
    this.add(e[t]);
}
vn.prototype.add = vn.prototype.push = fy;
vn.prototype.has = dy;
var py = vn;
function vy(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var hy = vy;
function gy(e, t) {
  return e.has(t);
}
var my = gy, by = py, yy = hy, $y = my, xy = 1, _y = 2;
function wy(e, t, n, r, a, o) {
  var i = n & xy, s = e.length, c = t.length;
  if (s != c && !(i && c > s))
    return !1;
  var l = o.get(e), v = o.get(t);
  if (l && v)
    return l == t && v == e;
  var u = -1, p = !0, d = n & _y ? new by() : void 0;
  for (o.set(e, t), o.set(t, e); ++u < s; ) {
    var m = e[u], h = t[u];
    if (r)
      var b = i ? r(h, m, u, t, e, o) : r(m, h, u, e, t, o);
    if (b !== void 0) {
      if (b)
        continue;
      p = !1;
      break;
    }
    if (d) {
      if (!yy(t, function($, y) {
        if (!$y(d, y) && (m === $ || a(m, $, n, r, o)))
          return d.push(y);
      })) {
        p = !1;
        break;
      }
    } else if (!(m === h || a(m, h, n, r, o))) {
      p = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), p;
}
var ts = wy, Cy = Ee, Ey = Cy.Uint8Array, Py = Ey;
function Sy(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, a) {
    n[++t] = [a, r];
  }), n;
}
var Oy = Sy;
function Ay(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Ty = Ay, no = Lt, ro = Py, Ry = Nr, jy = ts, Iy = Oy, Dy = Ty, My = 1, Ny = 2, Fy = "[object Boolean]", Ly = "[object Date]", ky = "[object Error]", Vy = "[object Map]", By = "[object Number]", Uy = "[object RegExp]", Hy = "[object Set]", Wy = "[object String]", zy = "[object Symbol]", Gy = "[object ArrayBuffer]", Ky = "[object DataView]", ao = no ? no.prototype : void 0, Kn = ao ? ao.valueOf : void 0;
function Yy(e, t, n, r, a, o, i) {
  switch (n) {
    case Ky:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Gy:
      return !(e.byteLength != t.byteLength || !o(new ro(e), new ro(t)));
    case Fy:
    case Ly:
    case By:
      return Ry(+e, +t);
    case ky:
      return e.name == t.name && e.message == t.message;
    case Uy:
    case Wy:
      return e == t + "";
    case Vy:
      var s = Iy;
    case Hy:
      var c = r & My;
      if (s || (s = Dy), e.size != t.size && !c)
        return !1;
      var l = i.get(e);
      if (l)
        return l == t;
      r |= Ny, i.set(e, t);
      var v = jy(s(e), s(t), r, a, o, i);
      return i.delete(e), v;
    case zy:
      if (Kn)
        return Kn.call(e) == Kn.call(t);
  }
  return !1;
}
var qy = Yy, Xy = Ji, Zy = ye;
function Jy(e, t, n) {
  var r = t(e);
  return Zy(e) ? r : Xy(r, n(e));
}
var Qy = Jy;
function e0(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, o = []; ++n < r; ) {
    var i = e[n];
    t(i, n, e) && (o[a++] = i);
  }
  return o;
}
var t0 = e0;
function n0() {
  return [];
}
var r0 = n0, a0 = t0, o0 = r0, i0 = Object.prototype, s0 = i0.propertyIsEnumerable, oo = Object.getOwnPropertySymbols, c0 = oo ? function(e) {
  return e == null ? [] : (e = Object(e), a0(oo(e), function(t) {
    return s0.call(e, t);
  }));
} : o0, l0 = c0;
function u0(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var f0 = u0, hn = { exports: {} };
function d0() {
  return !1;
}
var p0 = d0;
hn.exports;
(function(e, t) {
  var n = Ee, r = p0, a = t && !t.nodeType && t, o = a && !0 && e && !e.nodeType && e, i = o && o.exports === a, s = i ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
  e.exports = l;
})(hn, hn.exports);
var ns = hn.exports, v0 = Xe, h0 = Ur, g0 = Ze, m0 = "[object Arguments]", b0 = "[object Array]", y0 = "[object Boolean]", $0 = "[object Date]", x0 = "[object Error]", _0 = "[object Function]", w0 = "[object Map]", C0 = "[object Number]", E0 = "[object Object]", P0 = "[object RegExp]", S0 = "[object Set]", O0 = "[object String]", A0 = "[object WeakMap]", T0 = "[object ArrayBuffer]", R0 = "[object DataView]", j0 = "[object Float32Array]", I0 = "[object Float64Array]", D0 = "[object Int8Array]", M0 = "[object Int16Array]", N0 = "[object Int32Array]", F0 = "[object Uint8Array]", L0 = "[object Uint8ClampedArray]", k0 = "[object Uint16Array]", V0 = "[object Uint32Array]", G = {};
G[j0] = G[I0] = G[D0] = G[M0] = G[N0] = G[F0] = G[L0] = G[k0] = G[V0] = !0;
G[m0] = G[b0] = G[T0] = G[y0] = G[R0] = G[$0] = G[x0] = G[_0] = G[w0] = G[C0] = G[E0] = G[P0] = G[S0] = G[O0] = G[A0] = !1;
function B0(e) {
  return g0(e) && h0(e.length) && !!G[v0(e)];
}
var U0 = B0, H0 = U0, W0 = Dr, io = Oi, so = io && io.isTypedArray, z0 = so ? W0(so) : H0, rs = z0, G0 = f0, K0 = Br, Y0 = ye, q0 = ns, X0 = Vr, Z0 = rs, J0 = Object.prototype, Q0 = J0.hasOwnProperty;
function e$(e, t) {
  var n = Y0(e), r = !n && K0(e), a = !n && !r && q0(e), o = !n && !r && !a && Z0(e), i = n || r || a || o, s = i ? G0(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || Q0.call(e, l)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    X0(l, c))) && s.push(l);
  return s;
}
var t$ = e$, n$ = Object.prototype;
function r$(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || n$;
  return e === n;
}
var a$ = r$;
function o$(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var i$ = o$, s$ = i$, c$ = s$(Object.keys, Object), l$ = c$, u$ = a$, f$ = l$, d$ = Object.prototype, p$ = d$.hasOwnProperty;
function v$(e) {
  if (!u$(e))
    return f$(e);
  var t = [];
  for (var n in Object(e))
    p$.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var h$ = v$, g$ = Gi, m$ = Ur;
function b$(e) {
  return e != null && m$(e.length) && !g$(e);
}
var Wr = b$, y$ = t$, $$ = h$, x$ = Wr;
function _$(e) {
  return x$(e) ? y$(e) : $$(e);
}
var zr = _$, w$ = Qy, C$ = l0, E$ = zr;
function P$(e) {
  return w$(e, E$, C$);
}
var S$ = P$, co = S$, O$ = 1, A$ = Object.prototype, T$ = A$.hasOwnProperty;
function R$(e, t, n, r, a, o) {
  var i = n & O$, s = co(e), c = s.length, l = co(t), v = l.length;
  if (c != v && !i)
    return !1;
  for (var u = c; u--; ) {
    var p = s[u];
    if (!(i ? p in t : T$.call(t, p)))
      return !1;
  }
  var d = o.get(e), m = o.get(t);
  if (d && m)
    return d == t && m == e;
  var h = !0;
  o.set(e, t), o.set(t, e);
  for (var b = i; ++u < c; ) {
    p = s[u];
    var $ = e[p], y = t[p];
    if (r)
      var x = i ? r(y, $, p, t, e, o) : r($, y, p, e, t, o);
    if (!(x === void 0 ? $ === y || a($, y, n, r, o) : x)) {
      h = !1;
      break;
    }
    b || (b = p == "constructor");
  }
  if (h && !b) {
    var _ = e.constructor, w = t.constructor;
    _ != w && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof w == "function" && w instanceof w) && (h = !1);
  }
  return o.delete(e), o.delete(t), h;
}
var j$ = R$, I$ = Qe, D$ = Ee, M$ = I$(D$, "DataView"), N$ = M$, F$ = Qe, L$ = Ee, k$ = F$(L$, "Promise"), V$ = k$, B$ = Qe, U$ = Ee, H$ = B$(U$, "Set"), W$ = H$, z$ = Qe, G$ = Ee, K$ = z$(G$, "WeakMap"), Y$ = K$, dr = N$, pr = Fr, vr = V$, hr = W$, gr = Y$, as = Xe, wt = Ki, lo = "[object Map]", q$ = "[object Object]", uo = "[object Promise]", fo = "[object Set]", po = "[object WeakMap]", vo = "[object DataView]", X$ = wt(dr), Z$ = wt(pr), J$ = wt(vr), Q$ = wt(hr), ex = wt(gr), ze = as;
(dr && ze(new dr(new ArrayBuffer(1))) != vo || pr && ze(new pr()) != lo || vr && ze(vr.resolve()) != uo || hr && ze(new hr()) != fo || gr && ze(new gr()) != po) && (ze = function(e) {
  var t = as(e), n = t == q$ ? e.constructor : void 0, r = n ? wt(n) : "";
  if (r)
    switch (r) {
      case X$:
        return vo;
      case Z$:
        return lo;
      case J$:
        return uo;
      case Q$:
        return fo;
      case ex:
        return po;
    }
  return t;
});
var tx = ze, Yn = es, nx = ts, rx = qy, ax = j$, ho = tx, go = ye, mo = ns, ox = rs, ix = 1, bo = "[object Arguments]", yo = "[object Array]", Zt = "[object Object]", sx = Object.prototype, $o = sx.hasOwnProperty;
function cx(e, t, n, r, a, o) {
  var i = go(e), s = go(t), c = i ? yo : ho(e), l = s ? yo : ho(t);
  c = c == bo ? Zt : c, l = l == bo ? Zt : l;
  var v = c == Zt, u = l == Zt, p = c == l;
  if (p && mo(e)) {
    if (!mo(t))
      return !1;
    i = !0, v = !1;
  }
  if (p && !v)
    return o || (o = new Yn()), i || ox(e) ? nx(e, t, n, r, a, o) : rx(e, t, c, n, r, a, o);
  if (!(n & ix)) {
    var d = v && $o.call(e, "__wrapped__"), m = u && $o.call(t, "__wrapped__");
    if (d || m) {
      var h = d ? e.value() : e, b = m ? t.value() : t;
      return o || (o = new Yn()), a(h, b, n, r, o);
    }
  }
  return p ? (o || (o = new Yn()), ax(e, t, n, r, a, o)) : !1;
}
var lx = cx, ux = lx, xo = Ze;
function os(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !xo(e) && !xo(t) ? e !== e && t !== t : ux(e, t, n, r, os, a);
}
var Gr = os, fx = Gr;
function dx(e, t) {
  return fx(e, t);
}
var px = dx;
const vx = /* @__PURE__ */ je(px);
var hx = Xe, gx = Ze, mx = "[object Number]";
function bx(e) {
  return typeof e == "number" || gx(e) && hx(e) == mx;
}
var yx = bx;
const is = /* @__PURE__ */ je(yx), $x = "_trigger_1mrk9_1", xx = {
  trigger: $x
}, _x = he(function({
  title: t,
  metrics: n,
  children: r
}) {
  const a = /* @__PURE__ */ g.jsxs(K, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "1", color: "white", children: t }),
    n.length > 0 && /* @__PURE__ */ g.jsx(sr, { bounded: !0, children: n.map((o, i) => /* @__PURE__ */ g.jsx(_i, { instrument: o, theme: "dark" }, i)) })
  ] });
  return /* @__PURE__ */ g.jsx(
    Dt,
    {
      content: a,
      wrap: "div",
      wrapProps: { className: xx.trigger },
      children: r
    }
  );
}), wx = "_cell_1drwm_27", Cx = "_cellText_1drwm_37", Ex = "_cellDimmed_1drwm_40", Px = "_cellContent_1drwm_44", At = {
  cell: wx,
  cellText: Cx,
  cellDimmed: Ex,
  cellContent: Px
}, Jt = he(function({
  cell: t,
  dimmed: n = !1,
  background: r = "transparent",
  tooltipProps: a,
  textProps: o = {},
  onMouseEnter: i
}) {
  const [s, c] = Q(!1), l = Io(t == null ? void 0 : t.value);
  Mt(() => {
    if ((t == null ? void 0 : t.value) !== l) {
      c(!0);
      const p = setTimeout(() => {
        c(!1);
      }, 200);
      return () => {
        clearTimeout(p);
      };
    }
  }, [t == null ? void 0 : t.value]);
  const v = J(() => {
    if (!t) return null;
    const { value: p, format: d } = t;
    return typeof p == "string" ? p : typeof p == "number" && d ? Ft(p, d) : "—";
  }, [t]);
  if (!t)
    return /* @__PURE__ */ g.jsx(
      "div",
      {
        className: At.cell,
        onMouseEnter: i,
        "data-testid": "heatmap-instrument-cell"
      }
    );
  const u = /* @__PURE__ */ g.jsx("div", { className: At.cellContent, children: /* @__PURE__ */ g.jsx(
    W.Paragraph,
    {
      className: Oe({
        [At.cellText]: typeof t.value == "string"
      }),
      variant: "3",
      subdued: !is(t.value),
      ...o,
      children: v
    }
  ) });
  return /* @__PURE__ */ g.jsx(
    "div",
    {
      className: Oe(At.cell, {
        [At.cellDimmed]: n || s
      }),
      onMouseEnter: i,
      style: { backgroundColor: r },
      "data-animating": s,
      "data-testid": "heatmap-instrument-cell",
      children: a != null && a.enabled ? /* @__PURE__ */ g.jsx(_x, { ...a, children: u }) : u
    }
  );
}), Sx = "_grid_1az0f_27", Ox = "_row_1az0f_33", qn = {
  grid: Sx,
  row: Ox
};
var _o = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Ax(e, t) {
  return !!(e === t || _o(e) && _o(t));
}
function Tx(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!Ax(e[n], t[n]))
      return !1;
  return !0;
}
function Rx(e, t) {
  t === void 0 && (t = Tx);
  var n = null;
  function r() {
    for (var a = [], o = 0; o < arguments.length; o++)
      a[o] = arguments[o];
    if (n && n.lastThis === this && t(a, n.lastArgs))
      return n.lastResult;
    var i = e.apply(this, a);
    return n = {
      lastResult: i,
      lastArgs: a,
      lastThis: this
    }, i;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
const Xn = [
  "100",
  "200",
  "400",
  "500",
  "700"
].map((e) => k.purple[e]), jx = Rx(
  (e) => {
    if (e === null)
      return {
        backgroundColor: k.neutral["000"],
        color: "tertiary"
      };
    const t = Math.min(
      4,
      Math.floor(Math.min(e, 100) * (5 / 100))
    );
    return {
      backgroundColor: (Xn == null ? void 0 : Xn[t]) ?? k.neutral["000"],
      color: t >= 3 ? "white" : "primary"
    };
  }
);
function Ix(e) {
  return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
const Dx = (e) => {
  const t = e.flatMap(({ data: a }) => a.map((o) => Hr(o).value)).filter(Ix), n = Math.min(...t), r = Math.max(...t);
  return { min: n, max: r };
}, Mx = (e, { min: t, max: n }) => t === n ? 100 : Math.round(100 * (e - t) / (n - t)), Z_ = ({
  instrument: e
}) => {
  const {
    data: { categories: t, series: n }
  } = e, r = re(null), [a, o] = Ls({
    cell: null,
    column: null,
    row: null
  }), i = J(
    () => Object.values(a).some((d) => d !== null),
    [a]
  ), s = J(() => Dx(n), [n]);
  br(() => {
    const d = (m) => {
      r.current && !r.current.contains(m.target) && i && o.reset();
    };
    return window.addEventListener("mousemove", d, !0), () => {
      window.removeEventListener("mousemove", d, !0);
    };
  }, [i, o]);
  const c = q(
    (d) => {
      if (!i)
        return !1;
      const [m, h] = d;
      return a.cell ? !vx(a.cell.id, d) : a.column !== null ? a.column !== h : a.row !== null ? a.row !== m : !1;
    },
    [i, a.cell, a.column, a.row]
  ), l = q(
    (d) => o.setAll({
      cell: null,
      column: d,
      row: null
    }),
    [o]
  ), v = q(
    (d) => o.setAll({
      cell: null,
      column: null,
      row: d
    }),
    [o]
  ), u = q(
    (d) => {
      (i || d !== null) && o.setAll({
        cell: d,
        column: null,
        row: null
      });
    },
    [i, o]
  ), p = q(() => {
    i && o.reset();
  }, [i, o]);
  return /* @__PURE__ */ g.jsxs(
    "div",
    {
      ref: r,
      className: qn.grid,
      onMouseLeave: () => o.reset(),
      "data-testid": "heatmap-instrument",
      children: [
        /* @__PURE__ */ g.jsxs("div", { className: qn.row, children: [
          /* @__PURE__ */ g.jsx(Jt, { onMouseEnter: p }),
          n.map((d, m) => {
            const h = n[m].metrics ?? [];
            return /* @__PURE__ */ g.jsx(
              Jt,
              {
                cell: { id: [0, m], value: d.label },
                tooltipProps: {
                  enabled: h.length > 0,
                  title: d.label,
                  metrics: h
                },
                onMouseEnter: () => l(m)
              },
              d.label
            );
          })
        ] }),
        t.map((d, m) => {
          const h = t[m].metrics ?? [];
          return /* @__PURE__ */ g.jsxs("div", { className: qn.row, children: [
            /* @__PURE__ */ g.jsx(
              Jt,
              {
                cell: { id: [m, 0], value: d.label },
                tooltipProps: {
                  enabled: h.length > 0,
                  title: d.label,
                  metrics: h
                },
                onMouseEnter: () => v(m)
              }
            ),
            n.map((b, $) => {
              var A;
              const y = [m, $], { value: x, metrics: _ } = Hr(
                b.data[m]
              ), w = ((A = b.options) == null ? void 0 : A.format) ?? "number", E = is(x), { backgroundColor: O, color: S } = jx(
                E ? Mx(x, s) : null
              );
              return /* @__PURE__ */ g.jsx(
                Jt,
                {
                  cell: { id: y, value: x, format: w },
                  dimmed: c(y),
                  background: O,
                  tooltipProps: {
                    enabled: E,
                    title: `${d.label}, ${b.label}`,
                    metrics: _ != null && _.length ? _ : [
                      {
                        type: "metric",
                        title: "Total",
                        data: x,
                        format: w === "count" ? "number" : w
                      }
                    ]
                  },
                  textProps: { color: S },
                  onMouseEnter: () => u(E ? { id: y, value: x } : null)
                },
                y.join(",")
              );
            })
          ] }, d.label);
        })
      ]
    }
  );
}, Nx = "_legend_jf6br_27", Fx = "_trigger_jf6br_31", Lx = "_popover_jf6br_37", kx = "_breakdown_jf6br_56", Qt = {
  legend: Nx,
  trigger: Fx,
  popover: Lx,
  breakdown: kx
}, J_ = he(function({
  instrument: t
}) {
  const {
    data: { availability: n, media_type: r, away: a }
  } = t, o = [k.purple[700], k.neutral[200]], i = "No data available", s = {
    // Primitive way to ensure the labels are the same width, by deriving it from the longest
    // The number 7 is roughly the average width of a lowercase character
    labelWidth: Math.max(...r.map((u) => u.label.length)) * 7,
    theme: o
  }, c = () => /* @__PURE__ */ g.jsx(
    rn,
    {
      ...s,
      value: 0,
      label: "n.a.",
      theme: [k.neutral[200], k.neutral[200]],
      showFullBar: !0
    }
  ), l = () => {
    if (!a || !a.length) return null;
    const [u, p, ...d] = a;
    return /* @__PURE__ */ g.jsxs(pi, { children: [
      /* @__PURE__ */ g.jsx(vi, { asChild: !0, children: /* @__PURE__ */ g.jsx("div", { className: Qt.trigger, children: /* @__PURE__ */ g.jsx(yr, { variant: "tertiary", icon: "dots-h" }) }) }),
      /* @__PURE__ */ g.jsx(hi, { children: /* @__PURE__ */ g.jsx(gi, { side: "right", className: Qt.popover, children: /* @__PURE__ */ g.jsxs("ul", { className: Qt.breakdown, children: [
        /* @__PURE__ */ g.jsxs("li", { children: [
          /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "1", children: u.label }),
          /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "1", children: Ke(u.value) })
        ] }),
        /* @__PURE__ */ g.jsxs("li", { children: [
          /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "2", subdued: !0, children: p.label }),
          /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "2", subdued: !0, children: Ke(p.value) })
        ] }),
        /* @__PURE__ */ g.jsx(Ts, {}),
        d.map((m, h) => /* @__PURE__ */ g.jsxs("li", { children: [
          /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "2", children: m.label }),
          /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "1", children: Ke(m.value) })
        ] }, h))
      ] }) }) })
    ] });
  }, v = () => /* @__PURE__ */ g.jsxs(K, { gap: "300", className: Qt.legend, children: [
    n.map((u, p) => /* @__PURE__ */ g.jsxs(K, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ g.jsx(
        $r,
        {
          width: "6px",
          height: "6px",
          background: o[p],
          borderRadius: "50%"
        }
      ),
      /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "4", children: u.label })
    ] }, p)),
    l()
  ] });
  return /* @__PURE__ */ g.jsxs(K, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ g.jsxs(K, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "4", subdued: !0, children: n.length ? "Availability" : i }),
      n.length ? /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
        v(),
        /* @__PURE__ */ g.jsx(
          rn,
          {
            ...s,
            value: n[0].value,
            label: "Total",
            showFullBar: !0,
            showDifference: !0
          }
        )
      ] }) : c()
    ] }),
    /* @__PURE__ */ g.jsxs(K, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "4", subdued: !0, children: r.length ? "Availability per channel" : i }),
      r.length > 0 ? /* @__PURE__ */ g.jsx(K, { flexDirection: "column", gap: "200", children: r.map((u, p) => /* @__PURE__ */ B(
        rn,
        {
          ...s,
          key: p,
          value: u.value,
          label: u.label
        }
      )) }) : c()
    ] })
  ] });
}), Vx = "_tooltip_h4i5v_1", Bx = "_trigger_h4i5v_5", wo = {
  tooltip: Vx,
  trigger: Bx
}, Ux = ({
  text: e
}) => /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
  /* @__PURE__ */ g.jsx("span", { children: e }),
  /* @__PURE__ */ g.jsx(
    Dt,
    {
      className: wo.tooltip,
      content: e,
      wrap: "div",
      wrapProps: { className: wo.trigger }
    }
  )
] }), Hx = he(
  function({
    value: t
  }) {
    const [n, ...r] = t;
    return /* @__PURE__ */ g.jsxs(K, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "2", as: "span", children: n }),
      r.length > 0 && /* @__PURE__ */ g.jsx(Dt, { content: r.join(", "), children: /* @__PURE__ */ g.jsxs(W.ExternalLink, { as: "span", children: [
        "+ ",
        r.length,
        " more"
      ] }) })
    ] });
  }
), Wx = ({
  cell: e,
  format: t,
  timezone: n,
  customFormats: r
}) => {
  const a = J(() => {
    var i;
    if (!e || zx(e.value))
      return /* @__PURE__ */ g.jsx(W.Paragraph, { variant: "2", color: k.neutral[500], children: "n.a." });
    const { value: o } = e;
    if (r != null && r[t])
      return (i = r[t]) == null ? void 0 : i.call(r, { value: o });
    switch (t) {
      case "boolean":
        return o ? "Y" : "N";
      case "date":
        return Le.tz(o, n).format("L, LT");
      case "count":
        return yi(o);
      case "number":
        return It(o);
      case "percentage":
        return `${It(o)}%`;
      case "duration":
        return Ke(o);
      case "csid":
        return `#${o}`;
      case "rating":
        return `${o}`;
      case "presence":
        return /* @__PURE__ */ g.jsx(rn, { value: o, showFullBar: !0 });
      case "tags":
        return /* @__PURE__ */ g.jsx(Qs, { tags: o, limit: 1 });
      case "text":
        return /* @__PURE__ */ g.jsx(Ux, { text: o });
      case "list":
        return /* @__PURE__ */ g.jsx(Hx, { value: o });
      case "string":
      default:
        return `${o}`;
    }
  }, [e, r, t, n]);
  return /* @__PURE__ */ g.jsx(g.Fragment, { children: a });
};
function zx(e) {
  const t = e === null, n = typeof e == "string" && e.trim() === "", r = Array.isArray(e) && !e.length;
  return t || n || r;
}
const Gx = "_tableWrapper_1xmkm_1", Kx = "_tableWrapperEmpty_1xmkm_4", Yx = "_thCell_1xmkm_8", qx = "_tdCell_1xmkm_12", Xx = "_tooltip_1xmkm_20", Tt = {
  tableWrapper: Gx,
  tableWrapperEmpty: Kx,
  thCell: Yx,
  tdCell: qx,
  tooltip: Xx
};
function Zx(e) {
  return e == null;
}
var Jx = Zx;
const Qx = /* @__PURE__ */ je(Jx);
var e1 = es, t1 = Gr, n1 = 1, r1 = 2;
function a1(e, t, n, r) {
  var a = n.length, o = a, i = !r;
  if (e == null)
    return !o;
  for (e = Object(e); a--; ) {
    var s = n[a];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < o; ) {
    s = n[a];
    var c = s[0], l = e[c], v = s[1];
    if (i && s[2]) {
      if (l === void 0 && !(c in e))
        return !1;
    } else {
      var u = new e1();
      if (r)
        var p = r(l, v, c, e, t, u);
      if (!(p === void 0 ? t1(v, l, n1 | r1, r, u) : p))
        return !1;
    }
  }
  return !0;
}
var o1 = a1, i1 = Je;
function s1(e) {
  return e === e && !i1(e);
}
var ss = s1, c1 = ss, l1 = zr;
function u1(e) {
  for (var t = l1(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, c1(a)];
  }
  return t;
}
var f1 = u1;
function d1(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var cs = d1, p1 = o1, v1 = f1, h1 = cs;
function g1(e) {
  var t = v1(e);
  return t.length == 1 && t[0][2] ? h1(t[0][0], t[0][1]) : function(n) {
    return n === e || p1(n, e, t);
  };
}
var m1 = g1, b1 = En;
function y1(e, t, n) {
  var r = e == null ? void 0 : b1(e, t);
  return r === void 0 ? n : r;
}
var $1 = y1, x1 = Gr, _1 = $1, w1 = Zi, C1 = Mr, E1 = ss, P1 = cs, S1 = Vt, O1 = 1, A1 = 2;
function T1(e, t) {
  return C1(e) && E1(t) ? P1(S1(e), t) : function(n) {
    var r = _1(n, e);
    return r === void 0 && r === t ? w1(n, e) : x1(t, r, O1 | A1);
  };
}
var R1 = T1, j1 = En;
function I1(e) {
  return function(t) {
    return j1(t, e);
  };
}
var D1 = I1, M1 = Ai, N1 = D1, F1 = Mr, L1 = Vt;
function k1(e) {
  return F1(e) ? M1(L1(e)) : N1(e);
}
var V1 = k1, B1 = m1, U1 = R1, H1 = Pn, W1 = ye, z1 = V1;
function G1(e) {
  return typeof e == "function" ? e : e == null ? H1 : typeof e == "object" ? W1(e) ? U1(e[0], e[1]) : B1(e) : z1(e);
}
var K1 = G1;
function Y1(e) {
  return function(t, n, r) {
    for (var a = -1, o = Object(t), i = r(t), s = i.length; s--; ) {
      var c = i[e ? s : ++a];
      if (n(o[c], c, o) === !1)
        break;
    }
    return t;
  };
}
var q1 = Y1, X1 = q1, Z1 = X1(), J1 = Z1, Q1 = J1, e_ = zr;
function t_(e, t) {
  return e && Q1(e, t, e_);
}
var n_ = t_, r_ = Wr;
function a_(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!r_(n))
      return e(n, r);
    for (var a = n.length, o = t ? a : -1, i = Object(n); (t ? o-- : ++o < a) && r(i[o], o, i) !== !1; )
      ;
    return n;
  };
}
var o_ = a_, i_ = n_, s_ = o_, c_ = s_(i_), l_ = c_, u_ = l_, f_ = Wr;
function d_(e, t) {
  var n = -1, r = f_(e) ? Array(e.length) : [];
  return u_(e, function(a, o, i) {
    r[++n] = t(a, o, i);
  }), r;
}
var p_ = d_;
function v_(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
var h_ = v_, Co = kt;
function g_(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, a = e === e, o = Co(e), i = t !== void 0, s = t === null, c = t === t, l = Co(t);
    if (!s && !l && !o && e > t || o && i && c && !s && !l || r && i && c || !n && c || !a)
      return 1;
    if (!r && !o && !l && e < t || l && n && a && !r && !o || s && n && a || !i && a || !c)
      return -1;
  }
  return 0;
}
var m_ = g_, b_ = m_;
function y_(e, t, n) {
  for (var r = -1, a = e.criteria, o = t.criteria, i = a.length, s = n.length; ++r < i; ) {
    var c = b_(a[r], o[r]);
    if (c) {
      if (r >= s)
        return c;
      var l = n[r];
      return c * (l == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var $_ = y_, Zn = Ci, x_ = En, __ = K1, w_ = p_, C_ = h_, E_ = Dr, P_ = $_, S_ = Pn, O_ = ye;
function A_(e, t, n) {
  t.length ? t = Zn(t, function(o) {
    return O_(o) ? function(i) {
      return x_(i, o.length === 1 ? o[0] : o);
    } : o;
  }) : t = [S_];
  var r = -1;
  t = Zn(t, E_(__));
  var a = w_(e, function(o, i, s) {
    var c = Zn(t, function(l) {
      return l(o);
    });
    return { criteria: c, index: ++r, value: o };
  });
  return C_(a, function(o, i) {
    return P_(o, i, n);
  });
}
var T_ = A_, R_ = T_, Eo = ye;
function j_(e, t, n, r) {
  return e == null ? [] : (Eo(t) || (t = t == null ? [] : [t]), n = r ? void 0 : n, Eo(n) || (n = n == null ? [] : [n]), R_(e, t, n));
}
var I_ = j_;
const D_ = /* @__PURE__ */ je(I_), Po = (e, t) => {
  var n;
  return (n = e.cells.find((r) => r.column === t.key)) == null ? void 0 : n.value;
}, M_ = ({
  data: { columns: e, rows: t },
  limit: n = 50,
  sortStatus: r
}) => {
  const o = Math.ceil(t.length / n), [i, s] = Q(1);
  Mt(() => {
    i !== 1 && s(1);
  }, [r, o]);
  const c = J(() => {
    if (!r) return t;
    const v = e.find(({ key: u }) => u === r.sortBy);
    return v ? D_(
      t,
      [
        (u) => !Qx(Po(u, v)),
        (u) => Po(u, v)
      ],
      ["desc", r.direction]
    ) : t;
  }, [e, t, r]);
  return {
    rows: J(
      () => c.slice((i - 1) * n, i * n),
      [i, n, c]
    ),
    currentPage: i,
    totalPages: o,
    setPage: s
  };
}, Q_ = ({
  instrument: e,
  timezone: t,
  onReadInstruments: n,
  onLoadAll: r,
  onSortChange: a,
  customFormats: o
}) => {
  const {
    title: i,
    data: s,
    data: { columns: c, options: l }
  } = e, [v, u] = Q(null), p = re(null), d = (l == null ? void 0 : l.limit) ?? 50, { rows: m, currentPage: h, totalPages: b, setPage: $ } = M_({
    data: s,
    limit: d,
    sortStatus: v
  }), y = s.rows.length === 0, x = !!(l != null && l.next_page), _ = !x && b > 1;
  Mt(() => {
    p.current && (p.current.scrollTop = 0);
  }, [h]);
  const w = q(() => (r == null || r(), n({
    meta: {
      pagination: {
        limit: null
      }
    }
  })), [r, n]), E = q(
    async (O) => {
      x && await w(), u(O), a == null || a(O);
    },
    [w, a, x]
  );
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    i && /* @__PURE__ */ g.jsx("div", { children: /* @__PURE__ */ g.jsx(W.Heading, { variant: "heading-4", children: i }) }),
    /* @__PURE__ */ g.jsxs(
      me,
      {
        stickyHeader: !0,
        sortingProps: {
          sortStatus: v,
          onSortChange: E
        },
        wrapperProps: {
          className: Oe(Tt.tableWrapper, {
            [Tt.tableWrapperEmpty]: y
          })
        },
        wrapperRef: p,
        hoverable: !y,
        children: [
          /* @__PURE__ */ g.jsx(me.Thead, { children: /* @__PURE__ */ g.jsx(me.Tr, { children: c.map(({ key: O, label: S, sortable: A }) => /* @__PURE__ */ g.jsx(
            me.Th,
            {
              className: Tt.thCell,
              columnId: A ? O : null,
              children: S
            },
            S
          )) }) }),
          /* @__PURE__ */ g.jsxs(me.Tbody, { children: [
            y && /* @__PURE__ */ g.jsx(me.Tr, { children: /* @__PURE__ */ g.jsx(me.Td, { colSpan: c.length, children: /* @__PURE__ */ g.jsx(
              Ro,
              {
                title: "No data available",
                description: "There is no data available for the selected period and filters.",
                icon: "th"
              }
            ) }) }),
            m.map((O, S) => {
              const A = `row-${S}`;
              return /* @__PURE__ */ g.jsx(me.Tr, { children: c.map(({ key: U, format: j }, z) => {
                const D = O.cells.find((I) => I.column === U);
                return /* @__PURE__ */ g.jsx(
                  me.Td,
                  {
                    className: Tt.tdCell,
                    children: /* @__PURE__ */ g.jsx(
                      Wx,
                      {
                        cell: D,
                        format: j,
                        timezone: t,
                        customFormats: o
                      }
                    )
                  },
                  `${A}-cell-${z}`
                );
              }) }, A);
            })
          ] }),
          x && /* @__PURE__ */ g.jsx(me.Footer, { children: /* @__PURE__ */ g.jsxs(K, { alignItems: "center", justifyContent: "center", gap: "300", children: [
            /* @__PURE__ */ g.jsxs(K, { gap: "100", alignItems: "center", children: [
              /* @__PURE__ */ g.jsx(
                Rs,
                {
                  tooltipClassName: Tt.tooltip,
                  text: `By default we only load the first ${d} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
                }
              ),
              /* @__PURE__ */ g.jsxs(W.Paragraph, { variant: "2", children: [
                "Showing only the ",
                /* @__PURE__ */ g.jsxs("b", { children: [
                  "first ",
                  d,
                  " results"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ g.jsx(To, { variant: "secondary", onClick: w, children: "Load all results" })
          ] }) }),
          _ && /* @__PURE__ */ g.jsx(me.Footer, { children: /* @__PURE__ */ g.jsx(K, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ g.jsx(
            js,
            {
              pageCount: b,
              currentPage: h,
              pageRangeDisplayed: 6,
              onPageChange: $
            }
          ) }) })
        ]
      }
    )
  ] });
};
export {
  K_ as AnalyticsMenu,
  X_ as ChartInstrument,
  Z_ as HeatmapInstrument,
  _i as MetricInstrument,
  ff as MetricInstrumentData,
  sr as MetricInstrumentsGrid,
  rn as PercentageBar,
  J_ as PresenceInstrument,
  Q_ as TableInstrument,
  Y_ as categorizeInstruments,
  dt as chartAppearance,
  yi as formatAbbreviateNumber,
  Ft as formatInstrumentNumber,
  It as formatLocalizedNumber,
  Ke as formatMillisecondsToDuration,
  Hr as getChartSeriesValue,
  nf as isChartInstrument,
  rf as isHeatmapInstrument,
  q_ as isInsightInstrument,
  tf as isMetricInstrument,
  of as isPresenceInstrument,
  af as isTableInstrument,
  an as resolveChartElementColor,
  xi as resolveInstrumentColor
};
//# sourceMappingURL=index.js.map
